import {
  ChangeDetectorRef,
  Component,
  inject,
  ViewContainerRef,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationStart } from '@angular/router';
import { Overlay, ToastrService } from 'ngx-toastr';
import {
  Observable,
  startWith,
  map,
  tap,
  catchError,
  of,
  finalize,
  concatMap,
} from 'rxjs';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { FileUploadService } from 'src/app/shared/service/disbursment/file-upload.service';
import { PdaService } from 'src/app/shared/service/disbursment/pda.component.service';
import { PortAgentFormService } from 'src/app/shared/service/disbursment/port-agent-form.service';
import { PortService } from 'src/app/shared/service/disbursment/port.service';
import { FileUploadComponent } from '../../file-upload/file-upload.component';
import { MaCargo } from '../dis-repository/pages/create-cargo/cargo.model';
import { MaClient } from '../dis-repository/pages/create-client/client.model';
import { MaVessel } from '../dis-repository/pages/create-client/vessel.model';
import { MaPortAgent } from '../dis-repository/pages/create-port-agent/port-agent.model';
import { ConfirmationDialogComponent } from '../dis-repository/pages/create-port-tariff/confirmation-dialog.component';
import { MaCountry } from '../dis-repository/pages/create-port-tariff/country.model';
import { MaPort } from '../dis-repository/pages/create-port-tariff/port.model';
import { MaPurpose } from '../dis-repository/pages/create-purpose/purpose.model';
import {
  CommunicationHistory
} from '../fda-edit/comm-history.component.model';
import { ApprovalRequestDialogComponent } from '../fda/approval-request-dialog/approval-request-dialog.component';
import { EmailDialogComponent } from '../pda/email-dialog/email-dialog.component';
import { EmailSentNotificationComponent } from '../pda/email-sent-notification/email-sent-notification.component';
import {
  AddedFields,
  displayFn,
  autoCompleteFilter,
  validateVesselStay,
  restrictDecimal,
  getOptionValuefortheFields,
  onTotalFocus,
  onTotalBlur,
  getMainServiceSerialNumber,
  _filterCurrency,
  calculateVesselStay,
  addAdditionalFieldsToFieldsArray,
  displayClientComment,
  mergeResponseVesselIntoList,
  getCurrencyFromCountry,
  filterServicesOnPurpose,
  convertMinutesToDaysOrHours,
  removeAddedFieldsAndControls,
  getPurposeName,
  formatToLocalISOString,
  replaceMovementPart,
  getAdditionalPropertiesObjectFromForm,
  clearVesselDetails,
} from '../pda/pda.model';
import {
  fields,
  PA_Rules,
  convertVesselStayToMinutes,
  Field,
} from '../pda/port-agent-form.model';
import { ClientService } from 'src/app/shared/service/disbursment/client.service';
import { NotificationDialogComponent } from './push-notification.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { FileUploadDisComponent } from './file-upload-dis/file-upload-dis.component';

@Component({
  selector: 'app-pda-edit',
  templateUrl: './pda-edit.component.html',
  styleUrls: ['./pda-edit.component.scss'],
})
export class PdaEditComponent {
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;
  displayedColumns: string[] = [
    'S.No',
    'Service',
    'System Value',
    'Agent Value',
  ];
  hasInitializedExpansion = false;
  portAgentForm!: FormGroup;
  datasource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  countryList: MaCountry[] = [];
  portList: MaPort[] = [];
  vesselList: MaVessel[] = [];
  allVesselList: MaVessel[] = [];
  purposeList: MaPurpose[] = [];
  cargoList: MaCargo[] = [];
  clientList: MaClient[] = [];
  currencyList: string[] = [];
  portAgentList: MaPortAgent[] = [];
  fields = fields.map((field: any) => {
    if (field.name === 'Vessel') {
      return { ...field, value: 'vessel_id' };
    }
    return field;
  });
  serviceList: PA_Rules = new PA_Rules();
  pdaEditData: any = null;
  merakiServiceList: PA_Rules = new PA_Rules();
  mergedServiceList: any = [];
  agentServiceGrandTotal: number | null = null;
  agentServiceTotal = 0;
  merakiServiceTotal = 0;
  merakiServiceGrandTotal = 0;
  addedFields: AddedFields[] = [];
  canDeleteService: { [key: string]: boolean } = {};
  disableTableInputFields: boolean = false;
  portAgentReturnStatus: string | null = null;
  portAgentReturnMessage: string = '';
  displayAgreedAndNegotiateColumn: boolean = false;
  isNegotiateSelected: boolean = false;
  dis_id: string | null = sessionStorage.getItem('disbursement_seq');
  copyOfMasterData: any = {};
  isManualCreation: string | null = null;
  excludedFields = [
    'vessel_stay',
    'pda_roe',
    'voyage',
    'imo_number',
    'invoice_ref_no',
  ];
  errMsg: string = '';
  pdaApprovalRequest: string = '';
  serviceName: any = '';
  pdaStatus: number = 0;
  communicationHistory: CommunicationHistory[] = [];
  pdaState: string = 'Y';
  showRemittanceMismatchNote: boolean = false;
  pdaRemittanceFromResponse: number | null = null;
  showCurrencyConversionMismatchBanner: boolean = false;
  calculatedCurrencyConversion: string | null = null;
  responseCurrencyConversion: number | null = null;
  displayFn = displayFn;
  autoCompleteFilter = autoCompleteFilter;
  validateVesselStay = validateVesselStay;
  restrictDecimal = restrictDecimal;
  getOptionValue = getOptionValuefortheFields;
  onTotalFocus = onTotalFocus;
  onTotalBlur = onTotalBlur;
  portServiceList: PA_Rules = new PA_Rules();
  ConvertedFromCurrencyList: string[] = [];
  pda_custom_calculation!: FormControl;
  tariffRules: PA_Rules = new PA_Rules();
  filteredOptions: { [key: string]: any[] } = {};
  fileList: any = [];
  previousPurposeId: number | null = null;
  previousServiceData: any = null;
  displayConvertedToCurrency: boolean = false;
  filteredPaymentToCurrency: Observable<string[]> = new Observable<string[]>();
  filteredConvertedToCurrency: Observable<string[]> = new Observable<
    string[]
  >();
  convertedToCurrencyValue: string = '';
  PaymentFromCurrencyList: string[] = [];
  isPurposeChanged: boolean = false;
  previousPortId: number | null = null;
  previousCountryId: number | null = null;
  isPortChanged: boolean = false;
  calculatedRemittance: string | null = null;
  isInitialLoad: boolean = true;
  isRefreshingRules: boolean = false; // Flag to track refresh rules scenario
  rulesWereRefreshed: boolean = false; // Flag to track if rules were refreshed for API
  additionalFieldsFromRules: AddedFields[] = [];
  servicesNotInTariffRules: PA_Rules = new PA_Rules();
  username: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private portAgentFormService: PortAgentFormService,
    private snackBar: ToastrService,
    private portService: PortService,
    private pdaService: PdaService,
    private clientService: ClientService,
    private router: Router,
    private overlay: Overlay,
    private vcr: ViewContainerRef,
    private fileUploadService: FileUploadService,
    private cdr: ChangeDetectorRef,
     private requestFormService: RequestFormService,
  ) {
    this.buildPortAgentForm();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.dialog.closeAll();
      }
    });
  }
  // method to build the port agent form
  buildPortAgentForm() {
    this.portAgentForm = this.fb.group({
      client_id: [null, ],
      portagent_id: [null, ],
      cargo_id: [null, ],
      country_id: [null, ],
      port_id: [null, ],
      imo_number: [null, [, Validators.maxLength(7)]],
      vessel_id: [null],
      vessel: [null, ],
      nrt: [null, ],
      grt: [null, ],
      rgrt: [null],
      type: [null],
      loa: [null, ],
      beam: [null, ],
      depth: [null, ],
      dwt: [null, ],
      purpose_id: [null, ],
      eta: [null, []],
      etd: [null, []],
      vessel_stay: [null, ],
      pda_roe: [null, ],
      pda_currency_from: [null, ],
      pda_currency_to: [null, ],
      voyage: [null, ],
      serviceList: this.fb.array([] as FormGroup[]),
      advance_percentage: [null, [, Validators.max(100)]],
      conversion_rate: [null, ],
      currency_conversion: [null],
      Pda_remittance: [null],
      pda_custom_calculation: [false],
      invoice_ref_no: [null, ],
      converted_curr_from: [null],
      converted_curr_to: [null],
      conversion_pda_rate: [null],
      pmt_curr_from: [null],
      pmt_curr_to: [null],
    });
  }
  getMainServiceIndex = getMainServiceSerialNumber;

  // Returns the 'services' FormArray from the main form for easy access and manipulation
  get serviceListFormArray(): FormArray {
    return this.portAgentForm.get('serviceList') as FormArray;
  }
  modifiedFields: { [key: string]: boolean } = {};

  getFilteredOptions(field: any): any[] {
    return this.filteredOptions[field.value] || [];
  }

  ngOnInit() {
     this.username = localStorage.getItem('username') ?? '';
    this.pda_custom_calculation = this.portAgentForm.get(
      'pda_custom_calculation',
    ) as FormControl;
    this.getAllMasterData();
    this.fields.forEach((field) => {
      if (field.type === 'select') {
        this.autoCompleteFilter(
          field,
          this.portAgentForm,
          this.filteredOptions,
        );
      }
    });
    this.trackModifiedFieldChanges();
    this.pda_custom_calculation.valueChanges.subscribe((value) => {});

    this.filteredConvertedToCurrency =
      this.setupFilteredCurrency('converted_curr_to');
    this.filteredPaymentToCurrency = this.setupFilteredCurrency('pmt_curr_to');
  }

  private setupFilteredCurrency(controlName: string): Observable<string[]> {
    return this.portAgentForm.controls[controlName].valueChanges.pipe(
      startWith(''), // Start with an empty string to handle the initial case
      map((value) => _filterCurrency(this.currencyList, value)), // Apply filter to currency list
    );
  }

  // method to display the notification banner if the pda is return to  meraki
  returnRequestNotificationBanner(response?: any) {
    const handleResponse = (resp: any) => {
      this.communicationHistory = resp.communication_histories;
      this.copyOfMasterData = resp?.pda_vessel_details?.vsl_dtls || {};
      this.portAgentReturnStatus = resp.return_status;
      this.portAgentReturnMessage = resp.return_message;
      this.pdaApprovalRequest = resp.is_approved;
      this.tariffRules = resp?.port_tariff_rule;

      if (this.portAgentReturnStatus === 'Y') {
        this.dialog.open(NotificationDialogComponent, {
          data: {
            header: 'Request Returned',
            text: this.portAgentReturnMessage,
            color: '#FFEADF',
          },
          panelClass: 'custom-dialog-container',
          hasBackdrop: true,
          disableClose: true,
        });
      } else if (this.pdaApprovalRequest === 'Y') {
        this.dialog.open(NotificationDialogComponent, {
          data: {
            header: 'Request Approved',
            text: 'You have requested approval for this PDA. Please wait for the client to respond.',
            color: '#00FF007F',
          },
          panelClass: 'custom-dialog-container',
          hasBackdrop: true,
          disableClose: true,
        });
      } else if (this.pdaApprovalRequest === 'N') {
        this.dialog.open(NotificationDialogComponent, {
          data: {
            header: 'Request Rejected',
            text: 'You have requested approval for this PDA. Please wait for the client to respond.',
            color: '#FFEADF',
          },
          panelClass: 'custom-dialog-container',
          hasBackdrop: true,
          disableClose: true,
        });
      }
    };

    if (response) {
      handleResponse(response);
      return;
    }

    this.pdaService.pdaEditFormData(this.dis_id).subscribe({
      next: (resp: any) => {
        handleResponse(resp);
      },
      error: (err: any) => {
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  // method to highlight the modified fields
  trackModifiedFieldChanges() {
    Object.keys(this.portAgentForm.controls).forEach((field) => {
      this.portAgentForm.get(field)?.valueChanges.subscribe((value) => {
        let originalValue = this.copyOfMasterData[field];

        // Special handling for country_id and port_id
        if (
          field === 'country_id' &&
          this.pdaEditData?.pda?.portagent_pda_data?.country
        ) {
          originalValue =
            this.pdaEditData.pda.portagent_pda_data.country.country_id;
        } else if (
          field === 'port_id' &&
          this.pdaEditData?.pda?.portagent_pda_data?.port
        ) {
          originalValue = this.pdaEditData.pda.portagent_pda_data.port.port_id;
        }

        const currentVal =
          value === null || value === undefined ? '' : String(value).trim();
        const originalVal =
          originalValue === null || originalValue === undefined
            ? ''
            : String(originalValue).trim();
        this.modifiedFields[field] = currentVal !== originalVal;
      });
    });
  }

  // method to get the modified fields
  getModifiedFields() {
    const details = this.pdaEditData?.pda?.pda_vessel_details;
    this.modifiedFields = {};
    if (details) {
      Object.keys(details).forEach((key) => {
        this.modifiedFields[key] = !!details[key]?.modified;
      });
    }
  }

  isExcluded(fieldName: string): boolean {
    return this.excludedFields.includes(fieldName.toLowerCase());
  }

  // method to calculate the vessel stay on date change
  onDateChange() {
    const eta = this.portAgentForm.get('eta')?.value;
    const etd = this.portAgentForm.get('etd')?.value;

    const stay = calculateVesselStay(eta, etd);
    if (stay === 'eta greater than etd') {
      this.portAgentForm.get('vessel_stay')?.setValue(null);
      this.portAgentForm.get('etd')?.setValue(null);
    } else {
      this.portAgentForm.get('vessel_stay')?.setValue(stay);
    }
  }

  // methos to swap the fields for IMO Number and Vessel
  swapFields() {
    const imoIndex = this.fields.findIndex(
      (f) => f.name?.trim() === 'IMO Number',
    );
    const vesselIndex = this.fields.findIndex(
      (f) => f.name?.trim() === 'Vessel',
    );
    if (imoIndex !== -1 && vesselIndex !== -1) {
      const temp = this.fields[imoIndex];
      this.fields[imoIndex] = this.fields[vesselIndex];
      this.fields[vesselIndex] = temp;
      this.fields[imoIndex].type = 'select';
      this.fields[vesselIndex].type = 'input';
    }
  }

  isFieldReadonly(field: any): boolean {
    // Always make this specific field readonly based on your condition.
    if (field.readOnly && this.pdaEditData?.pda.is_manual_entry === 'N') {
      return true;
    }
    if (field.name === 'FromCurrency') {
      return true;
    }
    return false;
  }

  // method to set the data for the dropdown
  formatFieldData(fields: any[]) {
    fields.forEach((field: any) => {
      switch (field.name.trim()) {
        case 'Country':
          field.options = this.countryList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port Agent':
          field.options = this.portAgentList.map((agent: any) => ({
            portagent_id: agent.company_id,
            name: agent.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Client':
          field.options = this.clientList.map((client: any) => ({
            client_id: client.company_id,
            name: client.company_name,
          }));
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Cargo':
          field.options = this.cargoList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Port':
          field.options = this.portList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Vessel':
          field.options = this.vesselList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'Purpose':
          field.options = this.purposeList;
          this.filteredOptions[field.value] = field.options;
          break;
        case 'FromCurrency':
        case 'ToCurrency':
          field.options = this.currencyList;
          this.filteredOptions[field.value] = field.options;
          break;
        default:
      }
    });
    this.getPdaEditData();
  }

  // method to filter the ports based on country

  portByCountry(fieldName: string, value: any): Observable<any> {
    if (fieldName === 'Country') {
      return this.portService.getPortsByCountryId(value).pipe(
        tap((ports) => {
          this.portList = ports;

          // Process each field in the form
          this.fields.forEach((field) => {
            if (field.name === 'Port') {
              field.options = this.portList.map((port: any) => ({
                port_id: port.port_id,
                name: port.name,
              }));
            }
            this.filteredOptions[field.value] = field.options;
            this.portAgentForm
              .get('port_id')
              ?.setValue(this.pdaEditData.pda.portagent_pda_data.port.port_id);
          });

          const port_id = this.portAgentForm.get('port_id')?.value;
          this.addedFields = addAdditionalFieldsToFieldsArray(
            port_id,
            this.portList,
            this.fields,
            this.portAgentForm,
            this.addedFields,
            this.filteredOptions,
            this.fb,
          );
        }),
        catchError((error) => {
          this.portList = [];
          this.errMsg =
            error?.error?.error ||
            'Something went wrong, please try again later.';
          this.snackBar.error(this.errMsg);
          return of([]); // Return empty array in case of error
        }),
        finalize(() => {
          // Ensure loader is hidden after processing is complete
          this.loader.hide();
        }),
      );
    }

    // If fieldName isn't "Country", return an empty observable
    return of(null);
  }

  // method to post the pda edit data
  onPdaSubmit(buttonName: string) {
    if (!this.portAgentForm.valid) {
      this.portAgentForm.markAllAsTouched();
      this.snackBar.error('Please fill all required fields');
      return;
    }
    this.loader.show();
    this.getUploadedFiles().subscribe((files) => {
      if (this.fileList.length === 0) {
        this.snackBar.error('Please upload files before submitting.');
        this.loader.hide();
        return;
      }

      if (!this.agentServiceGrandTotal || this.agentServiceGrandTotal === 0) {
        this.snackBar.error('Please enter the agent value');
        return;
      }

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'sweet-alert-style',
        data: {
          header: 'Submit Data',
          text: "Once submitted, this PDA cannot be edited. If you do not wish to submit now, please click 'Save' to keep it in draft and modify it later.",
          button: 'Save',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'save') {
          this.pdaEditSubmitAndSave('save').subscribe((result) => {
            if (result) {
              const dialogRefChild = this.dialog.open(
                ConfirmationDialogComponent,
                {
                  data: {
                    header: 'Confirm Navigation',
                    text: 'Are you sure you want to navigate to the disbursement page?',
                  },
                },
              );
              dialogRefChild.afterClosed().subscribe((result) => {
                if (result) {
                  this.router.navigate(['/dis-disbursment']);
                }
              });
            }
          });
        } else if (result) {
          this.pdaEditSubmitAndSave(buttonName).subscribe((result) => {});
        }
      });
    });
  }

  pdaEditSubmitAndSave(buttonName: string): Observable<boolean> {
    if (buttonName === 'Re Request') {
      // checking the condition for the  return to pda
      if (this.portAgentReturnStatus === 'Y') {
        this.openReRequestEmailDialog('Re Request');
      }
      // if it is not return to pda then proceed with the negotiation re request
      else {
        const fieldsToExclude = [
          'advance_percentage',
          'conversion_rate',
          'currency_conversion',
          'pda_currency_from',
          'pda_currency_to',
          'pda_remittance',
        ];
        fieldsToExclude.forEach((field) => {
          const control = this.portAgentForm.get(field);
          if (control) {
            control.clearValidators();
            control.updateValueAndValidity();
          }
        });
        this.portAgentForm.markAllAsTouched();
        if (this.portAgentForm.valid) {
          const formData = this.portAgentForm.getRawValue();
          const submitData = this.transformJsonData(formData);
          this.loader.show();
          ((submitData.is_re_request = 'Y'),
            this.pdaService.pdaEditDataToDb(submitData).subscribe({
              next: (response) => {
                this.snackBar.success(response.message);
                this.router.navigate(['/dis-disbursment']);
                this.loader.hide();
              },
              error: (err) => {
                this.loader.hide();
                this.errMsg =
                  err?.error?.error ||
                  'Something went wrong please try again later.';
                this.snackBar.error(this.errMsg);
              },
            }));
        }
      }
    }

    // if the button id save or    submit   execute the below code
    else if (buttonName === 'Request Approval') {
      if (this.portAgentForm.valid) {
        this.openReRequestEmailDialog('Request Approval');
      } else {
        this.portAgentForm.markAllAsTouched();
        this.snackBar.error('Please fill all required fields');
      }
    } else {
      this.getUploadedFiles().subscribe({
        next: (files) => {
          const formData = this.portAgentForm.getRawValue();
          const submitData = this.transformJsonData(formData);
          submitData.pda_submit = buttonName === 'Submit' ? 'Y' : 'N';
          submitData.pda_save = buttonName === 'save' ? 'Y' : 'N';

          this.loader.show();
          this.pdaService
            .pdaEditDataToDb(submitData)
            .pipe(
              map((response) => {
                this.snackBar.success(response.message);
                this.loader.hide();
                return true;
              }),
              catchError((err) => {
                this.loader.hide();
                this.errMsg =
                  err?.error?.error ||
                  'Something went wrong, please try again later.';
                this.snackBar.error(this.errMsg);
                return of(false);
              }),
            )
            .subscribe((result) => {
              if (buttonName === 'Submit') {
                this.router.navigate(['/dis-disbursment']);
              } else {
                this.getPdaEditData();
              }
            });
        },
        error: (err) => {
          this.loader.hide();
          this.errMsg =
            err?.error?.error ||
            'Error fetching file data. Please try again later.';
          this.snackBar.error(this.errMsg);
        },
      });
    }

    return of(false);
  }

  // method to open the email dialog  if the port agent return the request to meraki
  openReRequestEmailDialog(buttonName: string) {
    const portAgent = this.portAgentList.filter(
      (agent) =>
        agent.company_id === this.portAgentForm.get('portagent_id')?.value,
    );
    const clientEmail = this.clientList.filter(
      (client) =>
        client.company_id === this.portAgentForm.get('client_id')?.value,
    );

    let dialogRef;

    // Open dialog based on the button clicked
    if (buttonName === 'Re Request') {
      dialogRef = this.dialog.open(EmailDialogComponent, {
        disableClose: true,
        panelClass: 'email-dialog-style',
        width: '800px',
        height: '500px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        data: {
          to: portAgent[0]?.email || '',
          cc: clientEmail[0]?.email || '',
        },
      });
    } else if (buttonName === 'Request Approval') {
      dialogRef = this.dialog.open(ApprovalRequestDialogComponent, {
        disableClose: true,
        position: { right: '0' },
        panelClass: ['animate__animated', 'animate__slideInRight'],
        width: '95%',
        height: '100%',
        maxWidth: '95vw',
        maxHeight: '100vh',
        data: {
          to: clientEmail[0]?.email || '',
          cc: clientEmail[0]?.email || '',
          services: {
            items: this.mergedServiceList,
            grand_Total:
              this.agentServiceGrandTotal !== null
                ? this.agentServiceGrandTotal.toFixed(2)
                : null,
          },
        },
      });
    }

    if (!dialogRef) {
      return;
    }

    // Handle the dialog result after it's closed
    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return; // If no data, do nothing

      const submitData = this.transformJsonData(
        this.portAgentForm.getRawValue(),
      );

      // Modify submitData based on the button clicked
      if (buttonName === 'Re Request') {
        submitData.email_to = data.to;
        submitData.email_cc = data.cc;
        submitData.email_signature = data.email_signature;
        submitData.update_signature = data.update_signature;
      } else if (buttonName === 'Request Approval') {
        ((submitData.pda_save = 'Y'),
          (submitData.portagent_pda_data.services = {
            items: data.services,
            grand_total: this.agentServiceGrandTotal,
          }));
      }

      // Perform the first API call (pdaEditDataToDb)
      this.loader.show();
      this.pdaService.pdaEditDataToDb(submitData).subscribe({
        next: (response) => {
          const payload = {
            disbursement_seq: response.disbursement_seq,
            email_to: data.to,
            email_cc: data.cc,
            meraki_cmt_to_client: data.meraki_comment_to_client,
            email_signature: data.email_signature,
            update_signature: data.update_signature,
          };

          // If button is 'Request Approval', call clientRequestPda
          if (buttonName === 'Request Approval') {
            this.pdaService.clientRequestPda(payload).subscribe({
              next: () => {
                this.loader.hide();
                this.showEmailSentNotification(data.to);
              },
              error: (err) => {
                this.loader.hide();
                this.handleError(err);
              },
            });
          } else {
            this.loader.hide();
            this.showEmailSentNotification(data.to);
          }
        },
        error: (err) => {
          this.loader.hide();
          this.handleError(err);
        },
      });
    });
  }

  // Method to show the Email Sent Notification dialog
  private showEmailSentNotification(email: string): void {
    const dialogRef = this.dialog.open(EmailSentNotificationComponent, {
      disableClose: true,
      panelClass: 'email-dialog-style',
      width: '400px',
      height: '150px',
      data: { email },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.router.navigate(['/dis-disbursment']);
      }
    });
  }

  // Method to handle error and display a message
  private handleError(err: any): void {
    this.errMsg =
      err?.error?.error || 'Something went wrong, please try again later.';
    this.snackBar.error(this.errMsg);
  }

  // method to exclude some fields for validation
  isFormValidExcept(fieldsToIgnore: string[]): boolean {
    return Object.keys(this.portAgentForm.controls).every((key) => {
      if (fieldsToIgnore.includes(key)) return true;

      const control = this.portAgentForm.get(key);

      if (!control) return true;

      // Ignore disabled controls
      if (control.disabled) return true;

      return control.valid;
    });
  }

  onSave(buttonName: string) {
    // Check if there's any new service that hasn't been submitted
    const newRow = this.serviceListFormArray.controls.find(
      (row) => row.get('isNew')?.value,
    );

    if (newRow) {
      const serviceControl = newRow.get('service');
      const serviceValue = serviceControl?.value;

      // If the new row has an empty service name, show error and return
      if (!serviceValue || serviceValue.trim() === '') {
        serviceControl?.markAsTouched();
        serviceControl?.markAsDirty();

        setTimeout(() => {
          const inputElement = document.querySelector<HTMLInputElement>(
            '.service-name.input-error',
          );
          if (inputElement) {
            inputElement.focus();
          }
        }, 0);

        this.snackBar.error(
          'Please submit the newly added service or remove it before saving',
        );
        return;
      } else {
        this.snackBar.error(
          'Please submit the newly added service before saving',
        );
        return;
      }
    }

    if (
      this.isFormValidExcept([
        'advance_percentage',
        'conversion_rate',
        'serviceList',
      ])
    ) {
      this.pdaEditSubmitAndSave(buttonName).subscribe((result) => {
        if (result) {
          const dialogRefChild = this.dialog.open(ConfirmationDialogComponent, {
            data: {
              header: 'Confirm Navigation',
              text: 'Do you wish to navigate to the disbursement page?',
            },
          });
          dialogRefChild.afterClosed().subscribe((result) => {
            if (result) {
              this.router.navigate(['/dis-disbursment']);
            } else {
              this.getPdaEditData();
            }
          });
        }
      });
    } else {
      Object.keys(this.portAgentForm.controls).forEach((key) => {
        if (
          ['advance_percentage', 'conversion_rate', 'serviceList'].includes(key)
        )
          return;

        const control = this.portAgentForm.get(key);
        control?.markAsTouched();
        control?.updateValueAndValidity();
      });

      this.snackBar.error('Please fill all required fields');
    }
  }

  // method to process the serviceList
  private populateServicesFromList() {
    this.serviceListFormArray.clear();
    this.datasource.data = [];
    if (this.mergedServiceList && Array.isArray(this.mergedServiceList)) {
      this.mergedServiceList.forEach((item: any) => {
        const subServiceArray = this.fb.array(
          (item.subService || []).map((sub: any) =>
            this.fb.group({
              SNO: [item.SNO],
              name: [sub.name],
              purpose: [sub.purpose],
              basic_value: [sub.basic_value],
              calculated_basic_value: [sub.calculated_basic_value],
              movement: [sub.movement],
              tariff_percent: [sub.tariff_percent],
              formula_result: [sub.formula_result],
              optional: [sub.optional === 'Y'],
              operational_flag: [sub.operational_flag],
              sub_total: [{ value: 0, disabled: this.disableTableInputFields }],
              formula_inputs: [sub.formula_inputs],
              hide: [sub.hide || 'N'],
              unique_key: [sub.unique_key],
              isSubService: [true],
              systemFormulaInputs: [sub.systemFormulaInputs || []],
              systemMovement: [sub.systemMovement || 0],
              formattedSystemMovement: [
                (() => {
                  const movement = sub.systemMovement;
                  if (typeof movement === 'string' && movement.includes(':')) {
                    const parts = movement.split(':');
                    const result = parts[1] || 1;
                    return result;
                  }

                  return movement || 1;
                })(),
              ],
              systemSubTotal: [
                {
                  value: sub.systemSubTotal,
                  disabled: this.disableTableInputFields,
                },
              ],
            }),
          ),
        );
        // Always set to 'Negotiate' if agent value > system value
        let initialAgreedOrNegotiate: string;

        if (
          item.negotiate === 'N' &&
          item.agreed === 'N' &&
          item.total > item.systemTotal
        ) {
          initialAgreedOrNegotiate = 'Negotiate';
        } else {
          if (this.isManualCreation === 'N') {
            if (item.negotiate === 'Y') {
              initialAgreedOrNegotiate = 'Negotiate';
            } else if (item.agreed === 'Y') {
              initialAgreedOrNegotiate = 'Agreed';
            } else {
              initialAgreedOrNegotiate = 'Agreed';
            }
          } else {
            initialAgreedOrNegotiate =
              item.negotiate === 'Y'
                ? 'Negotiate'
                : item.agreed === 'Y'
                  ? 'Agreed'
                  : 'Agreed';
          }
        }

        const mainServiceGroup = this.fb.group({
          SNO: [item.SNO],
          code: [item.code],
          total: [
            {
              value:
                item.total !== null &&
                item.total !== undefined &&
                item.total !== '' &&
                !isNaN(Number(item.total))
                  ? Number(item.total)
                  : null,
              disabled: this.disableTableInputFields,
            },
          ],
          service: [item.service || ''],
          purpose: [item.purpose || ''],
          pa_remark: [item.pa_remark || ''],
          meraki_feedback: [
            {
              value: item.meraki_feedback || '',
              disabled: this.disableTableInputFields,
            },
          ],
          meraki_remark_client: [item.meraki_remark_client || ''],
          client_comment: [item.client_comment || ''],
          formated_client_comment: [
            displayClientComment(item.client_comment) || '',
          ],
          client_option: [item.client_option || ''],
          info_msg: [item.info_msg || ''],
          negotiate: [initialAgreedOrNegotiate === 'Negotiate' ? 'Y' : 'N'],
          agreed: [initialAgreedOrNegotiate === 'Agreed' ? 'Y' : 'N'],
          subService: subServiceArray,
          isSubService: [false],
          expanded: [false],
          systemTotal: [
            typeof item.systemTotal === 'string' ? 0 : item.systemTotal || 0,
          ],
          agreedOrNegotiate: [initialAgreedOrNegotiate, Validators.required],
          display_to_client: [item.display_to_client || 'N'],
          //previous inclded the flag  to differentiate between manual check and automatic display of toggle button
          // manualAgreeOrNegotiate: ["N"]
        });
        this.serviceListFormArray.push(mainServiceGroup);
      });
    }
    this.updateDatasource();
  }

  // method to toggle the services
  toggleRow(service: FormGroup) {
    const isExpanded = service.get('expanded')?.value;
    service.get('expanded')?.setValue(!isExpanded);
    this.updateDatasource();
  }

  customAgentAedValues = new Map<AbstractControl, number>();

// Method triggered when user types in the secondary currency (AED) Agent Value field
onSecondaryAgentValueChange(service: AbstractControl, event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  const rawValue = inputElement.value;

  if (rawValue === '' || isNaN(Number(rawValue))) {
    this.customAgentAedValues.delete(service);
  } else {
    this.customAgentAedValues.set(service, Number(rawValue));
  }

  // Check toggle flags based on updated AED or USD values
  if (this.isManualCreation === 'Y') {
    this.onAgentValueChange(service as FormGroup);
  } else {
    this.updateAllToggleStatuses();
  }
}
  // method  to update the data source to display the subservices in the table
  updateDatasource() {
    this.datasource.data = [];
    let isExpanded = false;
    this.hasInitializedExpansion = false;
    for (let service of this.serviceListFormArray.controls) {
      const subServices = service.get('subService')?.value || [];
      // Auto-expand the first service that has subservices (only once)
      if (!this.hasInitializedExpansion && subServices.length > 0) {
        service.get('expanded')?.setValue(true);
        isExpanded = true;
      }
      // Push main service
      this.datasource.data.push(service);
      // If expanded, push subservices (reuse existing FormGroups from the form array)
      if (service.get('expanded')?.value) {
        const subServiceFormArray = service.get('subService') as FormArray;
        subServiceFormArray.controls.forEach((subServiceCtrl) => {
          this.datasource.data.push(subServiceCtrl);
        });
      }
    }
    this.hasInitializedExpansion = true;
    this.onSelectionChange(null);
    // this.loader.hide()
  }

  // method to open the add service dialog
  openCreateServiceDialog() {
    const newSNO = this.serviceListFormArray.length + 1;
    const serviceIndex = this.serviceListFormArray.length;
    const control = this.fb.group({
      SNO: [newSNO, { validators: Validators.required }],
      code: ['', { validators: Validators.required }],
      total: [0, { validators: Validators.required }],
      service: ['', { validators: Validators.required }],
      purpose: [''],
      pa_remark: [''],
      meraki_feedback: ['', { validators: Validators.required }],
      meraki_remark_client: [''],
      formated_client_comment: [''],
      client_comment: [''],
      client_option: [''],
      info_msg: [''],
      negotiate: ['N', { validators: Validators.required }],
      agreed: ['N', { validators: Validators.required }],
      subService: this.fb.array([]),
      systemTotal: [0],
      systemSubTotal: [0],
      expanded: [false],
      isNew: [true],
      isSubService: [false],
      pdaTotal: [0],
      agreedOrNegotiate: ['Agreed', Validators.required],
      serviceIndex: [serviceIndex],
    });

    // Add form control names
    Object.keys(control.controls).forEach((key) => {
      const ctrl = control.get(key);
      if (ctrl) {
        (ctrl as any).name = key;
      }
    });

    // Subscribe to service name changes to update delete permissions
    control.get('service')?.valueChanges.subscribe(() => {
      this.checkDeletePermission();
      this.updateDatasource();
    });

    this.serviceListFormArray.push(control);
    this.updateDatasource();
    this.checkDeletePermission();
  }

  // method to get the all master data
  getAllMasterData(): void {
    this.swapFields();
    this.loader.show();
    const params = {
      fields: ['all'],
    };
    this.portAgentFormService.getMasterData(params).subscribe({
      next: (response: any) => {
        this.countryList = response.country;
        this.purposeList = response.purpose;
        this.portAgentList = response.port_agent;
        this.clientList = response.client;
        this.cargoList = response.cargo;
        this.currencyList = response.currency;
        this.formatFieldData(this.fields);
      },
      error: (err: any) => {
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  private buildVesselOptions(vessels: any[]) {
    this.allVesselList = vessels || [];
    this.vesselList = this.allVesselList;
    this.fields.forEach((field) => {
      if (field.name === 'Vessel') {
        field.options = this.allVesselList.map((vessel: any) => ({
          vessel_id: vessel.vessel_id,
          name: vessel.name,
        }));
      }
      this.filteredOptions[field.value] = field.options;
    });
  }

  // method to get the vessel based on the client
  vesselListByClientId(clientId: number) {
    const vslpayload = {
      company_id: clientId,
      fields: ['assigned_unassigned'],
    };
    this.clientService.VslListFromDb(vslpayload).subscribe({
      next: (response: any) => {
        const mergedList = mergeResponseVesselIntoList(
          response.assigned_vessels || [],
          this.pdaEditData?.pda?.pda_vessel_details,
        );
        this.buildVesselOptions(mergedList);
        this.portAgentForm
          .get('vessel_id')
          ?.setValue(this.pdaEditData?.pda?.pda_vessel_details?.vessel_id);
      },
      error: (error: any) => {
        this.vesselList = [];
        this.errMsg = error?.error?.error || 'Failed to fetch vessel details';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  getPdaEditData() {
    this.loader.show();
    // Start the observable chain
    this.pdaService
      .pdaEditFormData(this.dis_id)
      .pipe(
        concatMap((response: any) => {
          this.isManualCreation = response.pda.is_manual_entry;
          this.pdaEditData = response;
          this.portAgentReturnStatus = response.return_status;
          this.pdaState = response.pda.state || 'Y';
          this.disableFields(
            response.pda.is_manual_entry,
            response.return_status,
          );
          this.pdaStatus = response.pda.status;

          const countryId = response.country_id;

          if (countryId) {
            const currency = getCurrencyFromCountry(
              this.countryList,
              countryId,
            );

            // Patch currency into form
            this.portAgentForm.patchValue({
              pda_currency_from: currency,
            });
            // Wait for portByCountry to complete before proceeding
            return this.portByCountry('Country', countryId).pipe(
              map(() => response),
            );
          } else {
            return of(response);
          }
        }),
        concatMap((response: any) => {
          // Check if manual entry
          if (response.pda.is_manual_entry === 'Y') {
            const requestBody = {
              page: 1,
              page_size: 1,
              query_name: '',
              port_id: response.pda.portagent_pda_data.port.port_id,
            };

            // Call portService.getTariffRules and proceed to next step
            return this.portService.getTariffRules(requestBody).pipe(
              map((tariffResponse: any) => {
                this.serviceList = tariffResponse?.data[0]?.rules;

                this.merakiServiceList = response.pda.meraki_pda_data.services;
                const purpose = response.pda?.portagent_pda_data?.purpose.name;
                this.portServiceList =
                  response.pda?.portagent_pda_data?.services;

                // Filter and merge service lists
                this.serviceList.items = filterServicesOnPurpose(
                  purpose,
                  this.portServiceList.items,
                );
                if (this.serviceList.items.length > 0) {
                  this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
                    this.merakiServiceList,
                    this.serviceList,
                  );
                  this.populateServicesFromList();
                }
                this.agentServiceGrandTotal = isNaN(
                  Number(response.pda.portagent_pda_data.services?.grand_total),
                )
                  ? null
                  : Number(
                      response.pda.portagent_pda_data.services?.grand_total,
                    );

                this.agentServiceTotal =
                  response.pda.portagent_pda_data.services.service_total;
                this.merakiServiceGrandTotal =
                  response.pda.meraki_pda_data.services.grand_total ?? 0;
                this.merakiServiceTotal =
                  response.pda.meraki_pda_data.services.service_total ?? 0;

                return response; // Pass response to the next chain
              }),
            );
          } else {
            // Handle non-manual entry
            if (
              response.pda.status === 1 &&
              response.pda?.meraki_pda_data?.services?.items.length === 0
            ) {
              this.serviceList = new PA_Rules();
              this.merakiServiceList = new PA_Rules();
              this.merakiServiceTotal = 0;
              this.agentServiceTotal = 0;
              this.agentServiceGrandTotal = null;
            } else {
              const columnsToAdd = ['Agreed / Negotiate'];
              const newColumns = columnsToAdd.filter(
                (col) => !this.displayedColumns.includes(col),
              );
              if (newColumns.length > 0) {
                this.displayedColumns.push(...newColumns);
                this.displayAgreedAndNegotiateColumn = true;
              }

              this.portServiceList = response.pda?.portagent_pda_data?.services;
              const purpose = response.pda?.portagent_pda_data?.purpose.name;

              if (purpose) {
                this.serviceList.items =
                  response.pda?.portagent_pda_data?.services?.items
                    ?.filter(
                      (item: any) =>
                        item.purpose === purpose ||
                        item.purpose === null ||
                        item.purpose === '',
                    )
                    .map((item: any) => {
                      item.total =
                        typeof item.total === 'string' ? 0 : item.total;
                      return item;
                    });
              }

              if (this.portAgentReturnStatus === 'Y') {
                this.serviceList = response.pda?.portagent_pda_data?.services;
              }

              this.merakiServiceList = response.pda?.meraki_pda_data?.services;
              this.agentServiceGrandTotal = isNaN(
                Number(response.pda.portagent_pda_data?.services?.grand_total),
              )
                ? null
                : Number(
                    response.pda.portagent_pda_data?.services?.grand_total,
                  );

              this.agentServiceTotal =
                response.pda.portagent_pda_data?.services.service_total;
              this.merakiServiceTotal =
                response.pda.meraki_pda_data?.services.service_total;
              this.merakiServiceGrandTotal =
                response.pda.meraki_pda_data?.services.grand_total ?? 0;

              this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
                this.merakiServiceList,
                this.serviceList,
              );
              this.populateServicesFromList();
            }

            return of(response); // Return response for further steps
          }
        }),
        concatMap((response: any) => {
          // Continue with the rest of the data processing after manual entry logic
          const purposeId = response.purpose_id;
          this.previousPurposeId = purposeId;
          this.previousPortId = response.port_id;
          this.previousCountryId = response.country_id;

          const portAgentFormData = response.pda.portagent_pda_data;
          const vesselDetails = response.pda.pda_vessel_details;
          const customCalcValue = response?.pda?.pda_custom_calculation === 'Y';
          this.pda_custom_calculation = new FormControl(customCalcValue);

          this.portAgentForm.patchValue({
            client_id: response.client_id,
            portagent_id: response.portagent_id,
            cargo_id: portAgentFormData?.cargo?.cargo_id,
            country_id: portAgentFormData?.country?.country_id,
            port_id: portAgentFormData?.port?.port_id,
            imo_number: vesselDetails?.vessel_imo,
            vessel_id: vesselDetails?.vessel_id,
            vessel: vesselDetails?.vessel_name,
            nrt: vesselDetails?.nrt?.current || null,
            grt: vesselDetails?.grt?.current || null,
            rgrt: vesselDetails?.rgrt?.current || null,
            type: vesselDetails?.type?.current || null,
            loa: vesselDetails?.loa?.current || null,
            beam: vesselDetails?.beam?.current || null,
            depth: vesselDetails?.depth?.current || null,
            dwt: vesselDetails?.dwt?.current || null,
            purpose_id: portAgentFormData?.purpose?.purpose_id,
            eta: response?.eta,
            etd: response?.etd,
            vessel_stay: convertMinutesToDaysOrHours(response.vessel_stay),
            pda_roe: response?.pda.pda_roe,
            voyage: response?.voyage,
            advance_percentage: response?.pda?.advance_percentage,
            Pda_remittance: response?.pda?.pda_remittance?.toFixed(2),
            conversion_rate: response?.pda.conversion_rate,
            currency_conversion: response?.pda?.portagent_pda_amount,
            pda_currency_from: response?.pda.pda_currency_from,
            pda_currency_to: response?.pda.pda_currency_to,
            invoice_ref_no: response?.pda.invoice_ref_no,
            converted_curr_from:
              response?.pda.converted_curr_from ||
              response?.pda.pda_currency_from,
            converted_curr_to:
              response?.pda.converted_curr_to || response?.pda.pda_currency_to,
            conversion_pda_rate: response?.pda.conversion_pda_rate || 1,
            pmt_curr_from:
              response?.pda.pmt_curr_from || response?.pda.pda_currency_from,
            pmt_curr_to:
              response?.pda.pmt_curr_to || response?.pda.pda_currency_to,
          });
          this.copyOfMasterData = { ...this.portAgentForm.getRawValue() };

          // Currency conversion display logic
          this.displayConvertedToCurrency =
            !!response?.pda?.converted_curr_to &&
            response?.pda?.converted_curr_to !==
              response?.pda?.pda_currency_to &&
            response?.pda?.converted_curr_to !==
              response?.pda?.pda_currency_from;

          this.convertedToCurrencyValue = response?.pda.converted_curr_to;
          this.ConvertedFromCurrencyList = [this.fromCurrency, this.toCurrency];
          this.PaymentFromCurrencyList = [this.fromCurrency, this.toCurrency];

          // Use updated tariff rules from response if available
          if (response?.port_tariff_rule) {
            this.tariffRules = response.port_tariff_rule;
            this.portServiceList = response.port_tariff_rule;
          } else {
            this.tariffRules = response?.port_tariff_rule;
          }

          this.pdaRemittanceFromResponse = response?.pda?.pda_remittance;
          this.responseCurrencyConversion = response?.pda?.portagent_pda_amount;

          this.handleAdditionalFields(response);

          // Calculate remittance on initial load to enable mismatch detection
          const advancePercentage = response?.pda?.advance_percentage;
          const currencyConversion = response?.pda?.currency_conversion;
          if (advancePercentage !== null && currencyConversion !== null) {
            this.calculatedRemittance = Number(
              (advancePercentage / 100) * currencyConversion,
            ).toFixed(2);
          }

          // Calculate currency conversion on initial load
          this.calculateCurrencyConversionForComparison();

          this.checkRemittanceMismatch();
          this.checkCurrencyConversionMismatch();
          this.getModifiedFields();

          // Disable the form if the status is completed
          if (response.pda.status === 7) {
            this.portAgentForm.disable();
            this.disableTableInputFields = true;
          }

          if (response.pda.status === 7) {
            const mergedList = mergeResponseVesselIntoList([], vesselDetails);
            this.buildVesselOptions(mergedList);
            return of(response);
          }

          // Wait for vessel list to load before hiding loader
          const vslpayload = {
            company_id: response.client_id,
            fields: ['assigned_unassigned'],
          };
          return this.clientService.VslListFromDb(vslpayload).pipe(
            map((vesselResponse: any) => {
              const mergedList = mergeResponseVesselIntoList(
                vesselResponse.assigned_vessels || [],
                vesselDetails,
              );
              this.buildVesselOptions(mergedList);
              this.portAgentForm
                .get('vessel_id')
                ?.setValue(
                  this.pdaEditData?.pda?.pda_vessel_details?.vessel_id,
                );
              return response;
            }),
            catchError((error: any) => {
              this.vesselList = [];
              this.errMsg =
                error?.error?.error || 'Failed to fetch vessel details';
              this.snackBar.error(this.errMsg);
              return of(response);
            }),
          );
        }),
        catchError((err) => {
          this.snackBar.error(
            'Something went wrong please try again later.',
          );
          return of(null);
        }),
        finalize(() => {
          // Only hide loader after ALL operations are complete
          this.loader.hide();
          this.isInitialLoad = false;
        }),
      )
      .subscribe((response) => {
        // Only show return/request banner after everything is loaded
        if (response) {
          this.returnRequestNotificationBanner(this.pdaEditData);
        }
      });
  }

  mergeSystemValueFromMerakiJson(
    merakiItems: PA_Rules,
    portAgentItems: PA_Rules,
  ) {
    if (this.isRefreshingRules) {
      return this.mergeAllMerakiServicesWithPortAgent(
        merakiItems,
        portAgentItems,
      );
    }
    return portAgentItems?.items?.map((portAgent) => {
      const matchedMerakiService = merakiItems?.items.find((meraki) => {
        const serviceMatch = meraki?.service === portAgent.service;
        const purposeMatch =
          (meraki?.purpose || '') === (portAgent.purpose || '');
        return serviceMatch && purposeMatch;
      });
      const systemTotal = matchedMerakiService
        ? matchedMerakiService.total || 0
        : 0;
      // Merge system values into existing port agent subservices
      const mergedSubServices = (matchedMerakiService?.subService || []).map(
        (sub) => {
          return {
            ...sub,
            systemSubTotal: sub?.sub_total || 0,
            systemFormulaInputs: sub?.formula_inputs || [],
            systemMovement: sub?.movement || '',
          };
        },
      );
      return {
        ...portAgent,
        systemTotal,
        subService: mergedSubServices,
        info_msg: matchedMerakiService?.info_msg || portAgent.info_msg || '',
      };
    });
  }

  mergeAllMerakiServicesWithPortAgent(
    merakiItems: PA_Rules,
    portAgentItems: PA_Rules,
  ) {
    return merakiItems?.items?.map((meraki) => {
      const matchedPortAgentService = portAgentItems?.items?.find(
        (portAgent) => {
          const serviceMatch = meraki?.service === portAgent.service;
          const purposeMatch =
            (meraki?.purpose || '') === (portAgent.purpose || '');
          return serviceMatch && purposeMatch;
        },
      );

      const mergedSubServices = (meraki?.subService || []).map((sub) => {
        return {
          ...sub,
          systemSubTotal: sub?.sub_total || 0,
          systemFormulaInputs: sub?.formula_inputs || [],
          systemMovement: sub?.movement || '',
        };
      });

      return {
        ...meraki,
        systemTotal: meraki.total || 0,
        total: matchedPortAgentService?.total || 0,
        pa_remark: matchedPortAgentService?.pa_remark || '',
        meraki_feedback: matchedPortAgentService?.meraki_feedback || '',
        meraki_remark_client:
          matchedPortAgentService?.meraki_remark_client || '',
        client_comment: matchedPortAgentService?.client_comment || '',
        client_option: matchedPortAgentService?.client_option || '',
        negotiate: matchedPortAgentService?.negotiate || 'N',
        agreed: matchedPortAgentService?.agreed || 'Y',
        display_to_client: matchedPortAgentService?.display_to_client || 'N',
        subService: mergedSubServices,
        info_msg: meraki?.info_msg || '',
      };
    });
  }

  onSelect(fieldName: string, event: any) {
    if (fieldName === 'Country') {
      if (event.value === this.previousCountryId) {
        return;
      }
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'sweet-alert-style',
        data: {
          header: 'Country Change Warning',
          text: 'Changing the country will reset the services. Do you want to continue?',
        },
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.previousCountryId = event.value;
          const currency = getCurrencyFromCountry(
            this.countryList,
            event.value,
          );
          this.portAgentForm.patchValue({
            pda_currency_from: currency,
          });
          this.loader.show();
          this.portService.getPortsByCountryId(event.value).subscribe({
            next: (ports) => {
              this.portList = ports;
              this.fields.forEach((field) => {
                if (field.name === 'Port') {
                  field.options = this.portList.map((port: any) => ({
                    port_id: port.port_id,
                    name: port.name,
                  }));
                }
              });
              this.filteredOptions['port_id'] = this.portList.map(
                (port: any) => ({
                  port_id: port.port_id,
                  name: port.name,
                }),
              );
              this.loader.hide();
            },
            error: (err: any) => {
              this.portList = [];
              this.filteredOptions['port_id'] = [];
              this.fields.forEach((field) => {
                if (field.name === 'Port') {
                  field.options = this.portList.map((port: any) => ({
                    port_id: port.port_id,
                    name: port.name,
                  }));
                }
              });
              this.loader.hide();

              this.errMsg =
                err?.error?.error ||
                'Something went wrong please try again later.';

              this.snackBar.error(this.errMsg);
            },
          });
          this.isPortChanged = true;
          this.addedFields = [];

          this.portAgentForm.patchValue({
            port_id: null,
            purpose_id: null,
            converted_curr_from: null,
            pmt_curr_from: null,
          });
          ((this.PaymentFromCurrencyList = []),
            (this.filteredConvertedToCurrency = new Observable<string[]>()));
          this.serviceList = new PA_Rules();
          this.merakiServiceList = new PA_Rules();
          this.agentServiceGrandTotal = 0;
          this.agentServiceTotal = 0;
          this.merakiServiceGrandTotal = 0;
          this.merakiServiceTotal = 0;
          this.datasource.data = [];
          this.previousPurposeId = null;
          this.previousPortId = null;
          removeAddedFieldsAndControls(
            this.portAgentForm,
            this.addedFields,
            this.fields,
          );
        } else {
          this.portAgentForm
            .get('country_id')
            ?.setValue(this.previousCountryId, { emitEvent: false });
          this.portAgentForm
            .get('port_id')
            ?.setValue(this.previousPortId, { emitEvent: false });
          this.portAgentForm
            .get('purpose_id')
            ?.setValue(this.previousPurposeId, { emitEvent: false });
          const purposeId = this.portAgentForm.get('purpose_id')?.value;
          const purpose = getPurposeName(this.purposeList, purposeId);
          if (purpose) {
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
          }
          this.populateServicesFromList();
        }
      });
    } else if (fieldName === 'Vessel') {
      const control = this.portAgentForm.get('vessel_id');
      const value = control?.value;
      const selectedVessel = this.vesselList.filter(
        (vessel) => vessel.vessel_id === value,
      );
      if (selectedVessel.length > 0) {
        const vessel = selectedVessel[0];
        this.portAgentForm.patchValue({
          imo_number: vessel.imo_number,
          nrt: vessel.nrt,
          grt: vessel.grt,
          rgrt: vessel.rgrt,
          depth: vessel.depth,
          loa: vessel.loa,
          beam: vessel.beam,
          dwt: vessel.dwt,
          vessel_id: vessel.vessel_id,
          vessel: vessel.name,
          type: vessel.type,
        });
        control?.setErrors(null);
      }
    } else if (fieldName === 'Client') {
      this.loader.show();
      const vslpayload = {
        company_id: this.portAgentForm.get('client_id')?.value,
        fields: ['assigned_unassigned'],
      };
      this.clientService.VslListFromDb(vslpayload).subscribe({
        next: (response: any) => {
          this.vesselList = response.assigned_vessels || [];
          this.formatFieldData(this.fields);
          this.loader.hide();
        },
        error: (error: any) => {
          this.vesselList = [];
          this.errMsg = error?.error?.error || 'Failed to fetch vessel details';
          this.snackBar.error(this.errMsg);
          this.loader.hide();
        },
      });
    } else if (fieldName === 'Port') {
      const port_id = event.value;
      // If first time selecting port (after country change), fetch data without warning
      if (!this.previousPortId) {
        this.previousPortId = port_id;
        this.tariffrulesByPort(port_id);
        this.addedFields = addAdditionalFieldsToFieldsArray(
          port_id,
          this.portList,
          this.fields,
          this.portAgentForm,
          this.addedFields,
          this.filteredOptions,
          this.fb,
        );
        return;
      }
      // If same port selected, do nothing
      if (port_id === this.previousPortId) {
        return;
      }

      // Different port selected, show warning
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'sweet-alert-style',
        data: {
          header: 'Port Change Warning',
          text: 'Changing the port will reset the services. Do you want to continue?',
        },
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.isPortChanged = true;
          this.previousPortId = port_id;
          this.tariffrulesByPort(port_id);
          this.addedFields = [];
          this.addedFields = addAdditionalFieldsToFieldsArray(
            port_id,
            this.portList,
            this.fields,
            this.portAgentForm,
            this.addedFields,
            this.filteredOptions,
            this.fb,
          );
          this.portAgentForm.get('purpose_id')?.setValue(null);
          this.serviceList = new PA_Rules();
          this.merakiServiceList = new PA_Rules();
          this.agentServiceGrandTotal = 0;
          this.agentServiceTotal = 0;
          this.merakiServiceGrandTotal = 0;
          this.merakiServiceTotal = 0;
          this.datasource.data = [];
          this.previousPurposeId = null;
          removeAddedFieldsAndControls(
            this.portAgentForm,
            this.addedFields,
            this.fields,
          );
        } else {
          this.portAgentForm
            .get('port_id')
            ?.setValue(this.previousPortId, { emitEvent: false });
          this.portAgentForm
            .get('purpose_id')
            ?.setValue(this.previousPurposeId, { emitEvent: false });
          const purposeId = this.portAgentForm.get('purpose_id')?.value;
          const purpose = getPurposeName(this.purposeList, purposeId);
          if (purpose) {
            this.serviceList.items = filterServicesOnPurpose(
              purpose,
              this.portServiceList.items,
            );
          }
          this.populateServicesFromList();
        }
      });
    } else if (fieldName === 'Purpose') {
      const purposeId = event.value;
      const portId = this.portAgentForm.get('port_id')?.value;

      this.isPurposeChanged = true;
      if (!this.previousPurposeId && portId) {
        // Port was changed, now purpose is being selected - don't show services
        this.previousPurposeId = purposeId;
        return;
      }

      if (this.previousPurposeId && purposeId !== this.previousPurposeId) {
        this.previousServiceData = {
          serviceList: JSON.parse(JSON.stringify(this.serviceList)),
          mergedServiceList: JSON.parse(JSON.stringify(this.mergedServiceList)),
          serviceFormArray: this.serviceListFormArray.getRawValue(),
          agentServiceGrandTotal:
            this.agentServiceGrandTotal !== null
              ? this.agentServiceGrandTotal.toFixed(2)
              : null,
        };
        this.showDataLostWarning();
      } else {
        this.previousPurposeId = purposeId;
        const purpose = getPurposeName(this.purposeList, purposeId);
        if (purpose) {
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
        }
        this.populateServicesFromList();
      }
    } else if (fieldName === 'Converted Currency To') {
      const value = event.value;
      this.displayConvertedToCurrency =
        this.fromCurrency !== value && this.toCurrency !== value;
      this.convertedToCurrencyValue = value;
      this.PaymentFromCurrencyList = [];
      this.PaymentFromCurrencyList = [this.fromCurrency, this.toCurrency];

      if (!this.PaymentFromCurrencyList.includes(value)) {
        this.PaymentFromCurrencyList.push(value);
      }
    } else if (fieldName === 'Payment Currency From') {
      this.calculatePercentage('Conversion Rate');
    }
  }

  transformJsonData(formData: any): any {
    const merakiPdaData = this.pdaEditData.pda.meraki_pda_data;
    const portAgentPdaData = this.pdaEditData.pda.portagent_pda_data;
    return {
      disbursement_seq: this.pdaEditData.disbursement_seq,
      disbursement_id: this.pdaEditData.disbursement_id,
      port_tariff_rule:
        this.isPurposeChanged && this.isPortChanged
          ? this.tariffRules
          : this.tariffRules?.items?.length > 0
            ? this.UpdateModifiedMovementToTariifRules()
            : null,
      client_id: formData.client_id,
      portagent_id: formData.portagent_id,
      country_id: formData.country_id,
      port_id: formData.port_id,
      pda_vsl_id: this.pdaEditData.vsl_id,
      purpose_id: formData.purpose_id,
      cargo_id: formData.cargo_id,
      voyage: formData.voyage,
      roe: formData.pda_roe,
      eta: formData.eta ? formatToLocalISOString(formData.eta) : null,
      etd: formData.etd ? formatToLocalISOString(formData.etd) : null,
      pda_currency_from: formData.pda_currency_from,
      pda_currency_to: formData.pda_currency_to,
      vessel: {
        vsl_id: formData.vessel_id,
        imo_number: formData.imo_number,
        name: formData.vessel,
        grt: formData.grt,
        rgrt: formData.rgrt,
        type: formData.type,
        nrt: formData.nrt,
        loa: formData.loa,
        beam: formData.beam,
        depth: formData.depth,
        dwt: formData.dwt,
        additional_properties: this.getAdditionalPropertiesFromForm(),
      },
      vessel_stay: convertVesselStayToMinutes(formData.vessel_stay),
      pda_custom_calculation:
        this.pdaEditData?.pda?.pda_custom_calculation || null,
      advance_percentage: formData.advance_percentage || null,
      conversion_rate: formData.conversion_rate || null,
      currency_conversion: formData.currency_conversion || null,
      pda_remittance: formData.Pda_remittance || null,
      meraki_pda_data: {
        disbursement_seq: merakiPdaData?.disbursement_seq || null,
        voyage: merakiPdaData?.voyage || null,
        eta: merakiPdaData?.eta || null,
        etd: merakiPdaData?.etd || null,
        pda_roe: merakiPdaData?.pda_roe || null,
        vessel_stay: merakiPdaData?.vessel_stay || null,
        client: {
          client_id: merakiPdaData?.client.client_id || null,
          name: merakiPdaData?.client.name || '',
          address: merakiPdaData?.client.address || '',
        },
        port_agent: {
          name: merakiPdaData?.port_agent.name || '',
          address: merakiPdaData?.port_agent.address || '',
          bank_details: {
            country_name:
              merakiPdaData?.port_agent.bank_details.company_name || '',
            beneficiary_acc_holder_name:
              merakiPdaData?.port_agent.bank_details
                .beneficiary_acc_holder_name || '',
            bank_name: merakiPdaData?.port_agent.bank_details.bank_name,
            correspondent_account_number:
              merakiPdaData?.port_agent.bank_details
                .correspondent_account_number || '',
            current_account_number:
              merakiPdaData?.port_agent.bank_details.current_account_number ||
              '',
            ifsc_code: merakiPdaData?.port_agent.bank_details.ifsc_code || '',
            bik_code: merakiPdaData?.port_agent.bank_details.bik_code || '',
            swift_code: merakiPdaData?.port_agent.bank_details.swift_code || '',
            currency: merakiPdaData?.port_agent.bank_details.currency || '',
            inn_code: merakiPdaData?.port_agent.bank_details.inn_code || '',
            iban_number:
              merakiPdaData?.port_agent.bank_details.iban_number || '',
            bic_code: merakiPdaData?.port_agent.bank_details.bic_code || '',
            branch_address:
              merakiPdaData?.port_agent.bank_details.branch_address || '',
          },
        },
        port: {
          port_id: formData.port_id,
          name:
            this.portList.find((port: any) => port.port_id === formData.port_id)
              ?.name || '',
        },
        country: {
          country_id: formData.country_id || '',
          name:
            this.countryList.find(
              (country: any) => country.country_id === formData.country_id,
            )?.name || '',
        },
        purpose: {
          purpose_id: merakiPdaData?.purpose.purpose_id || '',
          name: merakiPdaData?.purpose.name || '',
        },
        cargo: {
          cargo_id: merakiPdaData?.cargo.cargo_id || '',
          type: merakiPdaData?.cargo.type || '',
        },
        services: this.transFormServiceData(
          this.merakiServiceList,
          'merakiData',
        ),
      },
      portagent_pda_data: {
        disbursement_seq: portAgentPdaData?.disbursement_seq,
        voyage: formData.voyage,
        eta: formData.eta,
        etd: formData.etd,
        pda_roe: formData.pda_roe,
        vessel_stay: formData.vessel_stay,
        client: {
          client_id: formData.client_id,
          name:
            this.clientList.find(
              (client: any) => client.company_id === formData.client_id,
            )?.company_name || '',
          address:
            this.clientList.find(
              (client: any) => client.company_id === formData.client_id,
            )?.address || '',
        },
        port_agent: {
          name:
            this.portAgentList.find(
              (agent: any) => agent.company_id === formData.port_agent_id,
            )?.company_name || '',
          address: portAgentPdaData?.port_agent.address,
          bank_details: {
            country_name:
              portAgentPdaData?.port_agent.bank_details.company_name,
            beneficiary_acc_holder_name:
              portAgentPdaData?.port_agent.bank_details
                .beneficiary_acc_holder_name,
            bank_name: portAgentPdaData?.port_agent.bank_details.bank_name,
            correspondent_account_number:
              portAgentPdaData?.port_agent.bank_details
                .correspondent_account_number,
            current_account_number:
              portAgentPdaData?.port_agent.bank_details.current_account_number,
            ifsc_code: portAgentPdaData?.port_agent.bank_details.ifsc_code,
            bik_code: portAgentPdaData?.port_agent.bank_details.bik_code,
            swift_code: portAgentPdaData?.port_agent.bank_details.swift_code,
            currency: portAgentPdaData?.port_agent.bank_details.currency,
            inn_code: portAgentPdaData?.port_agent.bank_details.inn_code,
            iban_number: portAgentPdaData?.port_agent.bank_details.iban_number,
            bic_code: portAgentPdaData?.port_agent.bank_details.bic_code,
            branch_address:
              portAgentPdaData?.port_agent.bank_details.branch_address,
          },
        },
        port: {
          port_id: formData.port_id,
          name:
            this.portList.find((port: any) => port.port_id === formData.port_id)
              ?.name || '',
        },
        country: {
          country_id: formData.country_id,
          name:
            this.countryList.find(
              (country: any) => country.country_id === formData.country_id,
            )?.name || '',
        },
        purpose: {
          purpose_id: formData.purpose_id,
          name:
            this.purposeList.find(
              (purpose: any) => purpose.purpose_id === formData.purpose_id,
            )?.name || '',
        },
        cargo: {
          cargo_id: formData.cargo_id,
          type:
            this.cargoList.find(
              (cargo: any) => cargo.cargo_id === formData.cargo_id,
            )?.type || '',
        },
        pda_custom_calculation:
          this.pdaEditData?.pda_custom_calculation || null,
        advance_percentage: formData.advance_percentage || null,
        conversion_rate: formData.conversion_rate || null,
        currency_conversion: formData.currency_conversion || null,
        pda_remittance: formData.pda_remittance || null,
        is_rules_refreshed: this.rulesWereRefreshed ? 'Y' : 'N',
        vessel: {
          vsl_id: formData.vessel_id,
          imo_number: formData.imo_number,
          name: formData.vessel,
          grt: formData.grt,
          rgrt: formData.rgrt,
          type: formData.type,
          nrt: formData.nrt,
          loa: formData.loa,
          beam: formData.beam,
          depth: formData.depth,
          dwt: formData.dwt,
          additional_properties: this.getAdditionalPropertiesFromForm(),
          additional_properties_object:
            this.getAdditionalPropertiesObjectFromForm(),
        },
        services: this.isPurposeChanged
          ? this.serviceList
          : this.transFormServiceData(this.serviceList, 'agentData'),
      },
      email_to: this.pdaEditData.pda.email_to || null,
      email_cc: this.pdaEditData.pda.email_cc || null,
      pda_save: 'N',
      pda_submit: 'N',
      is_re_request: 'N',
      invoice_ref_no: formData.invoice_ref_no?.trim() || null,
      meraki_pda_amount: this.getMerakiPdaAmount(),
      portagent_pda_amount:
        formData.currency_conversion != null
          ? Number(formData.currency_conversion).toFixed(2)
          : null,
      file_list:
        this.fileList
          .filter((file: any) => file.sync === 'N')
          .map((file: any) => file.file_id) || [],
      converted_curr_from: formData.converted_curr_from || null,
      converted_curr_to: formData.converted_curr_to || null,
      conversion_pda_rate: formData.conversion_pda_rate || null,
      pmt_curr_from: formData.pmt_curr_from || null,
      pmt_curr_to: formData.pmt_curr_to || null,
    };
  }

  transFormServiceData(formData: any, serviceData: string) {
    return {
      items: this.serviceListFormArray.controls
        .map((ctrl: AbstractControl) => {
          let value = ctrl.getRawValue();
          if (value.code === null && serviceData === 'merakiData') {
            return null;
          }
          return {
            SNO: value.SNO ?? 0,
            code: value.code ?? null,
            total:
              serviceData === 'agentData'
                ? (value.total ?? null)
                : (value.systemTotal ?? null),
            service: value.service ?? null,
            purpose: value.purpose ?? null,
            pa_remark: value.pa_remark ?? null,
            meraki_feedback: value.meraki_feedback ?? null,
            meraki_remark_client: value.meraki_remark_client ?? null,
            client_comment: value.client_comment ?? null,
            client_option: value.client_option ?? null,
            info_msg: value.info_msg ?? null,
            negotiate:
              value.agreedOrNegotiate === 'Negotiate' &&
              serviceData === 'agentData'
                ? 'Y'
                : 'N',
            agreed:
              value.agreedOrNegotiate === 'Agreed' &&
              serviceData === 'agentData'
                ? 'Y'
                : 'N',
            display_to_client: value.display_to_client,
            subService: (value.subService || []).map((sub: any) => ({
              name: sub.name ?? null,
              purpose: sub.purpose ?? null,
              basic_value: sub.basic_value ?? null,
              calculated_basic_value: sub.calculated_basic_value ?? null,
              movement:
                serviceData === 'merakiData'
                  ? replaceMovementPart(
                      sub.movement,
                      1,
                      sub.formattedSystemMovement,
                    ) || '1'
                  : sub.movement,
              tariff_percent: sub.tariff_percent ?? 1,
              formula_result:
                sub.formula_result ?? 'Basic Value * movement * Tariff %',
              optional: sub.optional ? 'Y' : 'N',
              operational_flag: sub.operational_flag ?? '+',
              sub_total:
                serviceData === 'agentData'
                  ? (sub.sub_total ?? 0)
                  : (sub.systemSubTotal ?? 0),
              formula_inputs: sub.formula_inputs ?? null,
              hide: sub.hide ?? 'N',
              unique_key: sub.unique_key ?? null,
            })),
          };
        })
        .filter((item) => item !== null),
      grand_total:
        serviceData === 'agentData'
          ? this.agentServiceGrandTotal !== null
            ? Number(this.agentServiceGrandTotal.toFixed(2))
            : 0
          : Number(this.merakiServiceGrandTotal.toFixed(2)),
    };
  }

  // method to calculate the agentService total and grandTotal
  calculateAgentServiceGrandTotal() {
    this.agentServiceGrandTotal = this.serviceListFormArray.controls.reduce(
      (sum, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const totalValue = value.total != null ? Number(value.total) : 0;
        return sum + totalValue;
      },
      0,
    );

    if (this.portAgentForm.get('conversion_rate')?.value) {
      this.calculatePercentage('Conversion Rate');
    }
  }

  // Returns true if any agent total value exists (not null/empty)
  hasAgentValues(): boolean {
    return (
      !!this.serviceListFormArray &&
      this.serviceListFormArray.controls.some((ctrl: AbstractControl) => {
        const val = ctrl.get('total')?.value;
        return val !== null && val !== undefined && val !== '';
      })
    );
  }

  // Method to handle agent value changes and auto-toggle negotiate
  onAgentValueChange(service: FormGroup) {
    this.calculateAgentServiceGrandTotal();

    // Only auto-toggle to negotiate if isManualCreation === 'Y'
    if (this.isManualCreation === 'Y') {
      const agentValue = Number(service.get('total')?.value || 0);
      const systemValue = Number(service.get('systemTotal')?.value || 0);

      // Automatically set to negotiate if agent value is greater than system value
      if (agentValue > systemValue) {
        service.get('negotiate')?.setValue('Y');
        service.get('agreed')?.setValue('N');
        service.get('agreedOrNegotiate')?.setValue('Negotiate');
      } else {
        // Automatically set to agreed if agent value is equal or below system value
        service.get('negotiate')?.setValue('N');
        service.get('agreed')?.setValue('Y');
        service.get('agreedOrNegotiate')?.setValue('Agreed');
      }
    }
  }

  // Method to update toggle status for all services (used after recalculation)
  updateAllToggleStatuses() {
    this.serviceListFormArray.controls.forEach((service: AbstractControl) => {
      const serviceGroup = service as FormGroup;
      const agentValue = Number(serviceGroup.get('total')?.value || 0);
      const systemValue = Number(serviceGroup.get('systemTotal')?.value || 0);

      //previous if it is manually toggled  not changing the status on click of the checkbox
      // const isManualNegotiation = serviceGroup.get('manualAgreeOrNegotiate')?.value === "Y";
      // if (isManualNegotiation) {
      //   return;
      // }

      // Automatically set to negotiate if agent value is greater than system value
      if (agentValue > systemValue) {
        serviceGroup.get('negotiate')?.setValue('Y');
        serviceGroup.get('agreed')?.setValue('N');
        serviceGroup.get('agreedOrNegotiate')?.setValue('Negotiate');
      } else {
        // Automatically set to agreed if agent value is equal or below system value
        serviceGroup.get('negotiate')?.setValue('N');
        serviceGroup.get('agreed')?.setValue('Y');
        serviceGroup.get('agreedOrNegotiate')?.setValue('Agreed');
      }
    });

    // Update the global negotiate status
    this.isNegotiateSelected = this.serviceListFormArray.controls.some(
      (serviceItem: AbstractControl) =>
        (serviceItem as FormGroup).get('negotiate')?.value === 'Y',
    );

    this.updateDatasource();
  }

  // method to calculate the meraki grand total
  calculateMerakiServicegrandTotal() {
    this.merakiServiceGrandTotal = this.serviceListFormArray.controls.reduce(
      (sum: number, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const totalValue =
          value.systemTotal != null ? Number(value.systemTotal) : 0;
        return sum + totalValue;
      },
      0,
    );
    this.merakiServiceGrandTotal = parseFloat(
      this.merakiServiceGrandTotal.toFixed(2),
    );
  }

  // method to push the additional properties to the addedFields from the portAgentForm
  getAdditionalPropertiesFromForm(): { [key: string]: any } {
    const additionalProps: { [key: string]: any } = {};
    const dateFields = this.fields
      .filter((field) => field.type === 'date')
      .map((field) => field.name);
    this.addedFields.forEach(({ fieldName, controlName }) => {
      let value = this.portAgentForm.get(controlName)?.value ?? null;
      additionalProps[fieldName] = value;
      if (dateFields.includes(fieldName) && value) {
        additionalProps[fieldName] = formatToLocalISOString(value);
      }
    });
    return additionalProps;
  }

  // method to get additional properties as an array of objects with field details
  getAdditionalPropertiesObjectFromForm(): Array<{
    field_name: string;
    value: any;
    data_type: string;
    is_mandatory: string;
  }> {
    return getAdditionalPropertiesObjectFromForm(
      this.addedFields,
      this.portAgentForm,
      this.fields,
    );
  }

  // method to get the port tariff rule based on port id
  tariffrulesByPort(port_id: number) {
    this.serviceList = new PA_Rules();
    const requestBody = {
      page: 1,
      page_size: 1,
      query_name: '',
      port_id: port_id,
    };
    this.loader.show();
    this.portService.getTariffRules(requestBody).subscribe({
      next: (res) => {
        this.portServiceList = res?.data[0]?.rules;
        this.tariffRules = res?.data[0]?.rules;
        this.additionalFieldsFromRules = res?.data[0]?.vessel_fields || [];

        const purposeId = this.portAgentForm.get('purpose_id')?.value;
        const purpose = getPurposeName(this.purposeList, purposeId);

        if (this.isRefreshingRules) {
          // For refresh rules, create serviceList that only contains services that exist in Meraki data
          this.serviceList.items = (this.tariffRules.items || []).filter(
            (tariffItem: any) => {
              return this.merakiServiceList?.items?.some(
                (merakiService) => merakiService.service === tariffItem.service,
              );
            },
          );
          // Additional fields are already cleaned up in fetchPortTariffRulesAndRecalculate
          // Now add new fields from the refreshed rules
          const port_id = this.portAgentForm.get('port_id')?.value;
          this.addedFields = addAdditionalFieldsToFieldsArray(
            port_id,
            this.portList,
            this.fields,
            this.portAgentForm,
            this.addedFields,
            this.filteredOptions,
            this.fb,
          );
          // Call recalculate API after fetching fresh rules and adding fields
          this.recalculateData();
        } else {
          // Normal flow - filter by purpose
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
          if (this.isPurposeChanged) {
            this.recalculateData();
          }
        }

        this.loader.hide();
      },
      error: (err) => {
        this.isRefreshingRules = false; // Reset flag on error
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  // method to enable and disable the fileds based on requirement
  disableFields(is_manual_entry: string, portAgentReturnStatus: string | null) {
    if (is_manual_entry === 'Y') {
      this.portAgentForm.get('portagent_id')?.disable();
      this.portAgentForm.get('client_id')?.disable();
    } else if (is_manual_entry === 'N') {
      if (portAgentReturnStatus === null || portAgentReturnStatus === 'N') {
        this.portAgentForm.get('portagent_id')?.disable();
      } else if (portAgentReturnStatus === 'Y') {
        this.portAgentForm.get('portagent_id')?.enable();
      }
      this.portAgentForm.get('client_id')?.disable();
      this.portAgentForm.get('country_id')?.disable();
      this.portAgentForm.get('port_id')?.disable();
      this.portAgentForm.get('vessel_id')?.disable();
      this.portAgentForm.get('purpose_id')?.disable();
    }
  }

  // method to calculate the advance percentage and currency conversion rate
  calculatePercentage(name: string) {
    if (name === 'Advance Percentage') {
      const advancePercentage =
        +this.portAgentForm.get('advance_percentage')?.value || null;
      const currencyConversion = this.portAgentForm.get(
        'currency_conversion',
      )?.value;
      const calculatedValue =
        advancePercentage !== null && currencyConversion !== null
          ? (advancePercentage / 100) * currencyConversion
          : null;
      this.calculatedRemittance =
        calculatedValue !== null ? Number(calculatedValue).toFixed(2) : null;
      this.portAgentForm
        .get('Pda_remittance')
        ?.setValue(
          calculatedValue !== null ? Number(calculatedValue).toFixed(2) : null,
        );
    } else if (name === 'Conversion Rate') {
      let calculatedValue: number | null = null;
      const pmtCurrFrom = this.portAgentForm.get('pmt_curr_from')?.value;
      const roe = this.portAgentForm.get('pda_roe')?.value;
      const pdaConversionRoe = this.portAgentForm.get(
        'conversion_pda_rate',
      )?.value;
      const convertionRate =
        +this.portAgentForm.get('conversion_rate')?.value || null;
      if (this.fromCurrency === pmtCurrFrom) {
        calculatedValue =
          this.agentServiceGrandTotal !== null && convertionRate !== null
            ? this.agentServiceGrandTotal * convertionRate
            : null;
      } else if (this.toCurrency === pmtCurrFrom) {
        calculatedValue =
          this.agentServiceGrandTotal !== null && convertionRate !== null
            ? this.agentServiceGrandTotal * roe * convertionRate
            : null;
      } else if (
        this.convertedToCurrency === pmtCurrFrom &&
        this.convertedFromCurrency === this.toCurrency
      ) {
        calculatedValue =
          this.agentServiceGrandTotal !== null && convertionRate !== null
            ? this.agentServiceGrandTotal *
              roe *
              pdaConversionRoe *
              convertionRate
            : null;
      } else if (this.convertedToCurrency === pmtCurrFrom) {
        calculatedValue =
          this.agentServiceGrandTotal !== null && convertionRate !== null
            ? this.agentServiceGrandTotal * pdaConversionRoe * convertionRate
            : null;
      }

      this.portAgentForm
        .get('currency_conversion')
        ?.setValue(
          calculatedValue !== null ? Number(calculatedValue).toFixed(2) : null,
        );
      const advancePercentage =
        +this.portAgentForm.get('advance_percentage')?.value || null;
      const currencyConversion = this.portAgentForm.get(
        'currency_conversion',
      )?.value;
      const calculatedValueForRemittance =
        advancePercentage !== null && currencyConversion !== null
          ? (advancePercentage / 100) * currencyConversion
          : null;
      this.calculatedRemittance =
        calculatedValueForRemittance !== null
          ? Number(calculatedValueForRemittance).toFixed(2)
          : null;
      this.portAgentForm
        .get('Pda_remittance')
        ?.setValue(
          calculatedValueForRemittance !== null
            ? Number(calculatedValueForRemittance).toFixed(2)
            : null,
        );
    }
  }

  checkRemittanceMismatch(): void {
    // Only check for mismatch on initial load
    if (!this.isInitialLoad) {
      return;
    }

    if (
      this.pdaRemittanceFromResponse !== null &&
      this.calculatedRemittance !== null
    ) {
      const calculated = parseFloat(this.calculatedRemittance);
      const fromResponse = parseFloat(
        this.pdaRemittanceFromResponse.toString(),
      );
      const hasMismatch = Math.abs(calculated - fromResponse) > 0.01;
      if (hasMismatch) {
        this.showRemittanceMismatchNote = true;
      }
    }
  }

  calculateCurrencyConversionForComparison(): void {
    const pmtCurrFrom = this.portAgentForm.get('pmt_curr_from')?.value;
    const roe = this.portAgentForm.get('pda_roe')?.value;
    const pdaConversionRoe = this.portAgentForm.get(
      'conversion_pda_rate',
    )?.value;
    const conversionRate =
      +this.portAgentForm.get('conversion_rate')?.value || null;

    if (this.agentServiceGrandTotal === null || conversionRate === null) {
      this.calculatedCurrencyConversion = null;
      return;
    }

    let calculatedValue: number | null = null;

    if (this.fromCurrency === pmtCurrFrom) {
      calculatedValue = this.agentServiceGrandTotal * conversionRate;
    } else if (this.toCurrency === pmtCurrFrom) {
      calculatedValue = this.agentServiceGrandTotal * roe * conversionRate;
    } else if (
      this.convertedToCurrency === pmtCurrFrom &&
      this.convertedFromCurrency === this.toCurrency
    ) {
      calculatedValue =
        this.agentServiceGrandTotal * roe * pdaConversionRoe * conversionRate;
    } else if (this.convertedToCurrency === pmtCurrFrom) {
      calculatedValue =
        this.agentServiceGrandTotal * pdaConversionRoe * conversionRate;
    }

    this.calculatedCurrencyConversion =
      calculatedValue !== null ? Number(calculatedValue).toFixed(2) : null;
  }

  checkCurrencyConversionMismatch(): void {
    // Only show banner if PDA status is COMPLETED (status 7)
    if (this.pdaStatus !== 7) {
      this.showCurrencyConversionMismatchBanner = false;
      return;
    }

    // Only check for mismatch on initial load
    if (!this.isInitialLoad) {
      return;
    }

    if (
      this.responseCurrencyConversion !== null &&
      this.calculatedCurrencyConversion !== null
    ) {
      const calculated = parseFloat(this.calculatedCurrencyConversion);
      const fromResponse = parseFloat(
        this.responseCurrencyConversion.toString(),
      );
      const hasMismatch = Math.abs(calculated - fromResponse) > 0.01;
      if (hasMismatch) {
        this.showCurrencyConversionMismatchBanner = true;
      }
    }
  }

  refreshRemittance(): void {
    this.showRemittanceMismatchNote = false;
    if (this.calculatedRemittance !== null) {
      this.portAgentForm
        .get('Pda_remittance')
        ?.setValue(this.calculatedRemittance, { emitEvent: true });
      this.pdaRemittanceFromResponse = parseFloat(this.calculatedRemittance);
    }
  }

  onCheckboxClick(
    service: FormGroup,
    subServiceElement: any,
    subServiceIndex: number,
  ) {
    if (!service) return;

    const subServiceArray = service.get('subService') as FormArray;
    const subServiceControl = subServiceArray.at(subServiceIndex);
    if (!subServiceControl) return;

    // Toggle the 'optional' checkbox value
    const currentOptional = subServiceControl.get('optional')?.value;
    subServiceControl.get('optional')?.setValue(!currentOptional);

    let newSystemTotal = 0;

    // Recalculate the total by excluding the 'optional' items
    subServiceArray.controls.forEach((subCtrl) => {
      const isOptional = subCtrl.get('optional')?.value;

      let subTotal = 0;

      // Only include the total for non-optional services
      if (!isOptional) {
        subTotal = Number(subCtrl.get('systemSubTotal')?.value || 0);
        newSystemTotal += subTotal;
      }
    });

    // Ensure the total is non-negative
    newSystemTotal = Math.max(0, newSystemTotal);
    service.get('systemTotal')?.setValue(parseFloat(newSystemTotal.toFixed(2)));

    // Update grand total after the recalculation
    this.calculateMerakiServicegrandTotal();
  }

  // previous to set the flag Y if it the user manually setting the toggle.
  // agreeOrNegotiateManually(service: any) {
  //   service.get('manualAgreeOrNegotiate')?.setValue("Y")
  // }

  // method to get the service for the selected subservice
  getService(subserviceElement: any): any {
    for (let service of this.serviceListFormArray.controls) {
      const subServices = service.get('subService')?.value || [];
      const subserviceFound = subServices.find(
        (sub: any) => sub.name === subserviceElement.name,
      );
      if (subserviceFound) {
        return service;
      }
    }
    return null;
  }

  // Method to handle the change in selection ('Negotiate' or 'Agreed')
  onSelectionChange(event: any): void {
    const services = this.serviceListFormArray.value;
    const isAnyServiceNegotiate = services.some(
      (service: any) => service.agreedOrNegotiate === 'Negotiate',
    );
    if (isAnyServiceNegotiate) {
      this.isNegotiateSelected = true;
    } else {
      this.isNegotiateSelected = false;
    }
  }

  isDifferenceFlag(row: any) {
    if (
      Number(row.get('systemTotal')?.value) < Number(row.get('total')?.value) &&
      (this.isManualCreation === 'Y' ||
        (this.isManualCreation === 'N' &&
          row.get('agreedOrNegotiate')?.value !== 'Agreed'))
    ) {
      return true;
    } else {
      return false;
    }
  }

  // Method to determine if flag should be shown
  shouldShowFlag(service: FormGroup): boolean {
    const systemTotal = Number(service.get('systemTotal')?.value || 0);
    const agentTotal = Number(service.get('total')?.value || 0);

    if (this.isManualCreation === 'Y') {
      // For manual creation, show flag when agent value > system value
      return agentTotal > systemTotal;
    } else if (this.isManualCreation === 'N') {
      //previous For non-manual, show flag when agent value > system value AND not agreed

      // const agreedOrNegotiate = service.get('agreedOrNegotiate')?.value;
      // return agentTotal > systemTotal && agreedOrNegotiate !== 'Agreed';

      //current For non-manual, show flag when agent value > system value
      return agentTotal > systemTotal;
    }
    return false;
  }

  onSubServiceCheckboxChange(
    service: FormGroup,
    subServiceIndex: number,
    isChecked: boolean,
  ) {
    // Update the optional status in the subService data
    const subServices = service.get('subService')?.value || [];
    if (subServices[subServiceIndex]) {
      subServices[subServiceIndex].optional = isChecked;
      service.get('subService')?.setValue(subServices);
    }

    // Recalculate system total based on all subservice checkboxes
    this.calculateMerakiServicegrandTotal();
  }

  // Method to determine if service note should be shown
  shouldShowServiceNote(service: FormGroup): boolean {
    const systemTotal = Number(service.get('systemTotal')?.value || 0);
    const agentTotal = Number(service.get('total')?.value || 0);

    if (this.isManualCreation === 'Y') {
      // For manual creation, show note when agent value > system value
      return agentTotal > systemTotal;
    } else if (this.isManualCreation === 'N') {
      // For non-manual, show note in all cases where agent value > system value
      return agentTotal > systemTotal;
    }
    return false;
  }

  // Method to get service note message
  getServiceNoteMessage(service: FormGroup): string {
    const agreedOrNegotiate = service.get('agreedOrNegotiate')?.value;

    if (this.isManualCreation === 'Y') {
      return 'The agent value is greater than system value';
    } else if (this.isManualCreation === 'N') {
      if (agreedOrNegotiate === 'Agreed') {
        return "You're agreed to the agent value.";
      } else {
        return 'The agent value is greater than system value.';
      }
    }
    return '';
  }

  // Method to get service note CSS class
  getServiceNoteClass(service: FormGroup): string {
    const agreedOrNegotiate = service.get('agreedOrNegotiate')?.value;

    if (this.isManualCreation === 'N' && agreedOrNegotiate === 'Agreed') {
      return 'success';
    }
    return 'warning';
  }

  // Method to handle toggle change between Agreed/Negotiate
  onAgreedNegotiateToggle(service: FormGroup, isChecked: boolean): void {
    const systemTotal = Number(service.get('systemTotal')?.value || 0);
    const agentTotal = Number(service.get('total')?.value || 0);

    // Set negotiate value based on toggle
    if (isChecked) {
      service.get('negotiate')?.setValue('Y');
      service.get('agreedOrNegotiate')?.setValue('Negotiate');
    } else {
      service.get('negotiate')?.setValue('N');
      service.get('agreedOrNegotiate')?.setValue('Agreed');
    }

    // Update selection state for buttons
    this.onSelectionChange(null);
  }

  // method to recalculate the data
  recalculateData() {
    const formData = this.portAgentForm.getRawValue();
    const submitData = this.transformJsonData(formData);
    this.loader.show();
    submitData.pda_custom_calculation = this.pda_custom_calculation.value
      ? 'Y'
      : 'N';

    // Ensure updated tariff rules are sent to the API
    if (this.isRefreshingRules) {
      // For refresh rules, use the fresh tariff rules
      submitData.port_tariff_rule = this.tariffRules;
    } else {
      // For normal recalculation, use existing logic
      submitData.port_tariff_rule =
        this.isPurposeChanged && this.isPortChanged
          ? this.tariffRules
          : this.tariffRules?.items?.length > 0
            ? this.UpdateModifiedMovementToTariifRules()
            : null;
    }

    delete submitData.pda_save;
    delete submitData.pda_submit;
    delete submitData.is_re_request;
    this.pdaService.pdaReCalculate(submitData).subscribe({
      next: (response) => {
        this.previousPurposeId =
          response?.pda?.portagent_pda_data?.purpose?.purpose_id;
        this.previousPortId = response?.pda?.portagent_pda_data?.port?.port_id;
        this.previousCountryId =
          response?.pda?.portagent_pda_data?.country?.country_id;
        this.pdaEditData = response;
        this.tariffRules = response?.port_tariff_rule;
        this.serviceList = response.pda?.portagent_pda_data?.services;
        this.merakiServiceList = response.pda?.meraki_pda_data?.services;
        this.agentServiceGrandTotal =
          response.pda.portagent_pda_data.services?.grand_total ?? null;
        this.agentServiceTotal =
          response.pda.portagent_pda_data.services.service_total;
        this.merakiServiceTotal =
          response.pda.meraki_pda_data.services.service_total;
        this.merakiServiceGrandTotal =
          response.pda.meraki_pda_data.services.grand_total ?? 0;

        // Use appropriate merge method based on whether we're refreshing rules
        if (this.isRefreshingRules) {
          this.mergedServiceList = this.mergeAllMerakiServicesWithPortAgent(
            this.merakiServiceList,
            this.serviceList,
          );

          // If manual creation is 'N', add preserved services that don't exist in Meraki data
          if (
            this.isManualCreation === 'N' &&
            this.servicesNotInTariffRules.items?.length > 0
          ) {
            const preservedServices = this.servicesNotInTariffRules.items.map(
              (service: any) => ({
                ...service,
                systemTotal: 0, // Set system total to 0 for preserved services
                subService: service.subService || [],
              }),
            );
            this.mergedServiceList = [
              ...(this.mergedServiceList || []),
              ...preservedServices,
            ];
          }

          this.handleAdditionalFields(response);
          this.rulesWereRefreshed = true; // Set flag for API cal
          this.isRefreshingRules = false; // Reset flag after use
        } else {
          this.mergedServiceList = this.mergeSystemValueFromMerakiJson(
            this.merakiServiceList,
            this.serviceList,
          );
        }

        this.populateServicesFromList();
        this.isPurposeChanged = false;
        this.isPortChanged = false;
        // Update toggle status for all services after recalculation (only if not manual creation)
        if (this.isManualCreation !== 'Y') {
          this.updateAllToggleStatuses();
        }
        this.loader.hide();
        // Reset the flag after successful API call
      },
      error: (err) => {
        this.isRefreshingRules = false; // Reset flag on error
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
    this.hasInitializedExpansion = false;
  }

  UpdateModifiedMovementToTariifRules() {
    const updatedTariffItems = this.tariffRules?.items
      ?.map((tariffItem: any) => {
        const formService = this.serviceListFormArray.controls
          .map((c) => c.getRawValue())
          .find((s: any) => s.service === tariffItem.service);

        if (!formService) {
          return tariffItem; // Return original if no form service found
        }

        const updatedSubServices =
          tariffItem.subService?.map((tariffSub: any) => {
            // Find matching subservice in form data (excluding system-generated ones)
            const formSub = formService.subService?.find(
              (fs: any) =>
                fs.name === tariffSub.name &&
                !fs.unique_key?.includes('System'),
            );

            if (!formSub) {
              return tariffSub; // Return original if no match
            }
            const updatedSub = {
              ...tariffSub,
              optional: this.isRefreshingRules
                ? tariffSub?.optional === 'Y'
                  ? 'Y'
                  : 'N'
                : formSub?.optional === true || formSub?.optional === 'Y'
                  ? 'Y'
                  : 'N',
              movement: (() => {
                if (!tariffSub.movement) {
                  return tariffSub.movement;
                }
                const parts = tariffSub.movement.split(':');
                while (parts.length < 4) parts.push('NA');
                // Only update movement if we have a valid formattedSystemMovement
                if (
                  formSub.formattedSystemMovement !== undefined &&
                  formSub.formattedSystemMovement !== null
                ) {
                  parts[1] = formSub.formattedSystemMovement;
                }
                const finalMovement = parts.join(':');
                return finalMovement;
              })(),
            };
            return updatedSub;
          }) || [];

        return {
          ...tariffItem,
          subService: updatedSubServices,
        };
      })
      .filter(Boolean);
    return { items: updatedTariffItems };
  }

  // Method to get system grand total (sum of all system totals)
  getSystemGrandTotal(): number | null {
    return this.serviceListFormArray.controls.reduce(
      (sum, ctrl: AbstractControl) => {
        const value = ctrl.value;
        const systemTotal =
          value.systemTotal != null ? Number(value.systemTotal) : null;
        if (systemTotal === null) {
          return sum;
        }
        const result = sum + systemTotal;
        return Number(result.toFixed(2));
      },
      0,
    );
  }

  /** Opens the file upload dialog. you can add a Upload button and call this function in which component it is required by Rahul*/
  upload(): void {
    const disbursementId = this.pdaEditData?.disbursement_id;
    const disbursementSeq = this.pdaEditData?.disbursement_seq;

    const pdaId = this.pdaEditData?.pda.pda_id;
    const data = {
      files: [],
      disbursementId,
      pdaId,
      pdaOrFda: 'PDA',
      disbursement_seq: disbursementSeq,
      isDisbursement: false,
      source_type: 'Meraki',
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '96vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(FileUploadDisComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
      }
    });
  }

  // method to download the report
  downloadReport() {
    const report_type = 'PDA';
    const reportData = {
      disbursement_seq: this.pdaEditData.disbursement_seq,
      report_type: report_type,
    };
    this.loader.show();
    this.fileUploadService
      .downloadReport(reportData, this.pdaEditData.disbursement_id)
      .subscribe({
        next: () => {
          this.loader.hide();
        },
        error: (error: any) => {
          this.loader.hide();
          this.errMsg =
            error.message || 'Something went wrong please try again later.';
          this.snackBar.error(this.errMsg);
        },
      });
  }

  private handleAdditionalFields(response: any): void {
    let additionalProperties: any[] = [];
    // Override additionalProperties when refreshing - add ALL fields from rules without conditions
    if (this.isRefreshingRules) {
      additionalProperties = (this.additionalFieldsFromRules || []).map(
        (rule: any) => ({
          field_name: rule?.field_name,
          is_mandatory: rule?.is_mandatory,
          value: null, // Set to null for refresh to ensure clean state
        }),
      );
    } else {
      additionalProperties =
        response?.pda?.pda_vessel_details?.additional_property || [];
    }
    // Get current field names from additionalProperties (trimmed)
    const currentFieldNames = additionalProperties
      .map((item: any) => item?.field_name?.trim())
      .filter(Boolean);
    const fieldsToRemove = this.addedFields.filter((field) => {
      const exists = currentFieldNames.includes(field.fieldName?.trim());
      return !exists;
    });
    // Remove fields that are no longer needed
    fieldsToRemove.forEach((field) => {
      if (this.portAgentForm.contains(field.controlName)) {
        this.portAgentForm.removeControl(field.controlName);
      }
      // Remove from fields array
      const fieldIndex = this.fields.findIndex(
        (f) => f.value === field.controlName,
      );
      if (fieldIndex > -1) {
        this.fields.splice(fieldIndex, 1);
      }
    });

    // Add missing fields into this.fields
    additionalProperties.forEach((item: any) => {
      const fieldName = item?.field_name?.trim();
      if (!fieldName) return;

      const existsInFields = this.fields.some(
        (f: any) => f.value?.trim() === fieldName,
      );

      if (!existsInFields) {
        this.fields.push({
          name: fieldName, // Add name property for display
          label: fieldName,
          value: fieldName,
          type: 'input', // Add default type
        });

        // Add form control if it doesn't exist
        if (!this.portAgentForm.contains(fieldName)) {
          const isMandatory = item?.is_mandatory === 'Y';
          const value = item?.value ?? null;
          this.portAgentForm.addControl(
            fieldName,
            this.fb.control(value, isMandatory ? Validators.required : []),
          );
        }
      }
    });

    // Update addedFields to only include current fields
    this.addedFields = additionalProperties?.map((item: any) => ({
      fieldName: item?.field_name,
      controlName: item?.field_name,
      is_mandatory: item?.is_mandatory,
    }));

    // Add/update current fields
    this.addedFields?.forEach((field: any) => {
      const matchingProp = additionalProperties?.find((prop: any) => {
        return prop?.field_name === field.fieldName;
      });
      const isMandatory = field.is_mandatory === 'Y';
      const value = matchingProp?.value ?? null;

      if (!this.portAgentForm.contains(field.controlName)) {
        this.portAgentForm.addControl(
          field.controlName,
          this.fb.control(value, isMandatory ? Validators.required : []),
        );
      } else {
        this.portAgentForm.get(field.controlName)?.patchValue(value);
      }
    });

    // Trigger change detection to update UI
    this.cdr.detectChanges();
  }

  submitServiceName(service: FormGroup) {
    const serviceNameControl = service.get('service');

    if (
      !serviceNameControl ||
      !serviceNameControl.value ||
      serviceNameControl.value.trim() === ''
    ) {
      this.snackBar.error('Please enter a service name');
      return;
    }

    const serviceName = serviceNameControl.value.trim();

    // Check if this service name already exists in the form array
    const isDuplicate = this.serviceListFormArray.controls.some((ctrl, idx) => {
      const currentIndex = this.serviceListFormArray.controls.indexOf(service);
      if (idx === currentIndex) return false;

      const existingServiceName = ctrl.get('service')?.value;
      return (
        existingServiceName &&
        existingServiceName.trim().toLowerCase() === serviceName.toLowerCase()
      );
    });

    if (isDuplicate) {
      this.snackBar.error(
        'A service with this name already exists. Please use a different name.',
      );
      return;
    }
    service.get('isNew')?.setValue(false);
    service.markAsPristine();
    service.updateValueAndValidity();

    this.snackBar.success('Service name saved');
    this.updateDatasource();
    this.checkDeletePermission();
  }

  private checkDeletePermission() {
    // Reset the delete permissions
    this.canDeleteService = {};

    if (!this.tariffRules?.items) {
      this.serviceListFormArray.controls.forEach((_, index) => {
        this.canDeleteService[index] = true;
      });
      return;
    }

    // Create a map of services from port tariff rules (case-insensitive)
    const portTariffServicesMap = new Map(
      (this.tariffRules.items || [])
        .filter(
          (rule) =>
            rule && typeof rule.service === 'string' && rule.service !== null,
        )
        .map((rule) => [rule.service!.trim().toLowerCase(), true]),
    );

    // Check each service in the current table
    this.serviceListFormArray.controls.forEach((control, index) => {
      this.serviceName = control.get('service')?.value;

      if (!this.serviceName) {
        this.canDeleteService[index] = true;
        return;
      }

      const normalizedServiceName = this.serviceName.trim().toLowerCase();
      const existsInTariffRules = portTariffServicesMap.has(
        normalizedServiceName,
      );

      this.canDeleteService[index] = !existsInTariffRules;
    });
  }

  canDeleteSpecificService(service: FormGroup): boolean {
    if (!service) {
      return true;
    }

    const code = service.get('code')?.value;
    if (!code || code === '' || code === null) {
      return true;
    }

    const serviceName = service.get('service')?.value;

    if (!serviceName || serviceName.trim() === '') {
      return true;
    }

    if (!this.tariffRules?.items || this.tariffRules.items.length === 0) {
      return true;
    }

    // Check if service exists in port tariff rules (case-insensitive)
    const normalizedServiceName = serviceName.trim().toLowerCase();
    const existsInTariffRules = this.tariffRules.items.some(
      (rule) =>
        rule &&
        typeof rule.service === 'string' &&
        rule.service !== null &&
        rule.service.trim().toLowerCase() === normalizedServiceName,
    );

    return !existsInTariffRules;
  }

  deleteService(service: FormGroup) {
    const index = this.serviceListFormArray.controls.indexOf(service);
    if (index === -1) return;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: { header: 'Delete', text: 'Do you want to delete the service?' },
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
      if (result) {
        this.serviceListFormArray.removeAt(index);
        this.updateDatasource();
        this.checkDeletePermission();
        this.calculateAgentServiceGrandTotal();
      }
    });
  }

  onRemove(field: Field): void {
    if (
      field?.name === 'Country' &&
      !this.portAgentForm.get('country_id')?.value
    ) {
      this.portList = [];
      this.portAgentForm.get('port_id')?.setValue(null);
      this.portAgentForm.get('purpose_id')?.setValue(null);
      this.filteredOptions['port_id'] = [];
      this.filteredOptions['purpose_id'] = [];
      this.serviceList.items = [];
      this.datasource.data = [];
    } else if (
      field?.name === 'Port' &&
      !this.portAgentForm.get('port_id')?.value
    ) {
      this.portAgentForm.get('purpose_id')?.setValue(null);
      this.serviceList.items = [];
      this.datasource.data = [];
    } else if (
      field?.name === 'Vessel' &&
      !this.portAgentForm.get('vessel_id')?.value
    ) {
      clearVesselDetails(this.portAgentForm);
    }
  }

  getUploadedFiles(): Observable<any> {
    const data = {
      disbursement_seq: this.pdaEditData?.disbursement_seq,
      pda_fda_flag: 'PDA',
    };
    this.loader.show();
    return this.fileUploadService.fileDataFromDb(data).pipe(
      map((res) => {
        this.fileList = res;
        this.loader.hide();
      }),
      catchError((err) => {
        this.loader.hide();
        this.errMsg =
          err?.error?.error || 'Something went wrong. Please try again later.';
        this.snackBar.error(this.errMsg);
        return of([]);
      }),
    );
  }

  // method to refresh tariff rules with warning dialog
  refreshTariffRules() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Replace Tariff Rules',
        text: 'Are you sure you want to replace the current PDA tariff with the latest tariff from the repository? Please note this would also remove the additional vessel property data.',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.fetchPortTariffRulesAndRecalculate();
      }
    });
  }

  // method to fetch port tariff rules and recalculate
  private fetchPortTariffRulesAndRecalculate() {
    const portId = this.portAgentForm.get('port_id')?.value;
    if (!portId) {
      this.snackBar.error('Port is required to fetch tariff rules');
      return;
    }
    if (this.isManualCreation === 'N') {
      // console.log("Refreshing tariff rules - preserving user changes for non-manual creation", this.serviceList.items, this.tariffRules?.items);
      const servicesNotInTariffRules =
        this.serviceList?.items?.filter((existingService: any) => {
          return !this.tariffRules.items?.some(
            (tariffService: any) =>
              tariffService.service === existingService.service,
          );
        }) || [];
      // Store preserved services for later use in tariffrulesByPort
      this.servicesNotInTariffRules.items = servicesNotInTariffRules;
    }

    // Set flag to indicate we're refreshing rules
    this.isRefreshingRules = true;
    // Use existing method to fetch tariff rules
    this.tariffrulesByPort(portId);

    this.snackBar.success('Tariff rules refreshed successfully.');
  }

  resendPdaRequest() {
    this.loader.show();
    const data = { disbursement_seq: this.pdaEditData?.disbursement_seq };
    this.pdaService.resendPdaLink(data).subscribe({
      next: (response) => {
        this.loader.hide();
        this.snackBar.success(response.message);
      },
      error: (error) => {
        this.loader.hide();
        this.errMsg =
          error?.error?.error ||
          'Something went wrong. Please try again later.';
        this.snackBar.error(this.errMsg);
      },
    });
  }

  // method to show the dialog when the purpose is changes
  showDataLostWarning() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: 'Data Loss Warning',
        text: 'Are you sure you want to change the purpose? This will reset the services.',
      },
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
      if (result) {
        const purposeId = this.portAgentForm.get('purpose_id')?.value;
        const port_id = this.portAgentForm.get('port_id')?.value;
        this.tariffrulesByPort(port_id);
        this.agentServiceGrandTotal = null;
        this.portAgentForm.patchValue({
          advance_percentage: null,
          conversion_rate: null,
          currency_conversion: null,
          Pda_remittance: null,
        });
        const purpose = getPurposeName(this.purposeList, purposeId);
        if (purpose) {
          this.serviceList.items = filterServicesOnPurpose(
            purpose,
            this.portServiceList.items,
          );
        }
        this.populateServicesFromList();
        this.recalculateData();
      } else {
        // Restore previous purpose and associated data
        this.portAgentForm.get('purpose_id')?.setValue(this.previousPurposeId);

        // Restore previous service data
        if (this.previousServiceData) {
          this.serviceList = this.previousServiceData.serviceList;
          this.mergedServiceList = this.previousServiceData.mergedServiceList;
          this.agentServiceGrandTotal =
            this.previousServiceData.agentServiceGrandTotal;

          this.serviceListFormArray.clear();
          this.previousServiceData.serviceFormArray.forEach(
            (serviceData: any) => {
              const subServiceArray = this.fb.array(
                (serviceData.subService || []).map((sub: any) =>
                  this.fb.group({
                    SNO: [serviceData.SNO],
                    name: [sub.name],
                    purpose: [sub.purpose],
                    basic_value: [sub.basic_value],
                    calculated_basic_value: [sub.calculated_basic_value],
                    movement: [sub.movement],
                    tariff_percent: [sub.tariff_percent],
                    formula_result: [sub.formula_result],
                    optional: [sub.optional],
                    operational_flag: [sub.operational_flag],
                    sub_total: [sub.sub_total],
                    formula_inputs: [sub.formula_inputs],
                    hide: [sub.hide],
                    unique_key: [sub.unique_key],
                    isSubService: [true],
                    systemFormulaInputs: [sub.systemFormulaInputs],
                    systemMovement: [sub.systemMovement],
                    formattedSystemMovement: [sub.formattedSystemMovement],
                    systemSubTotal: [sub.systemSubTotal],
                  }),
                ),
              );

              const serviceGroup = this.fb.group({
                SNO: [serviceData.SNO],
                code: [serviceData.code],
                total: [serviceData.total],
                service: [serviceData.service],
                purpose: [serviceData.purpose],
                pa_remark: [serviceData.pa_remark],
                meraki_feedback: [serviceData.meraki_feedback],
                meraki_remark_client: [serviceData.meraki_remark_client],
                client_comment: [serviceData.client_comment],
                formated_client_comment: [serviceData.formated_client_comment],
                client_option: [serviceData.client_option],
                info_msg: [serviceData.info_msg],
                negotiate: [serviceData.negotiate],
                agreed: [serviceData.agreed],
                subService: subServiceArray,
                isSubService: [false],
                expanded: [serviceData.expanded],
                systemTotal: [serviceData.systemTotal],
                agreedOrNegotiate: [serviceData.agreedOrNegotiate],
                display_to_client: [serviceData.display_to_client],
              });
              this.serviceListFormArray.push(serviceGroup);
            },
          );
          this.updateDatasource();
        }
      }
    });
  }

  get fromCurrency(): string {
    return this.portAgentForm?.get('pda_currency_from')?.value || '';
  }
  get toCurrency(): string {
    return this.portAgentForm?.get('pda_currency_to')?.value || '';
  }

  get convertedToCurrency(): string {
    return this.portAgentForm?.get('converted_curr_to')?.value || '';
  }

  get convertedFromCurrency(): string {
    return this.portAgentForm?.get('converted_curr_from')?.value || '';
  }

calculateSystemAndAgentValueWithRoe(
  service: AbstractControl,
  type: string,
  conversion_type: string,
): number | null {
  // Return custom overridden AED value if present
  if (type === 'agent' && conversion_type === 'ToCurrency' && this.customAgentAedValues.has(service)) {
    return this.customAgentAedValues.get(service) ?? null;
  }

  const roe = Number(this.portAgentForm.get('pda_roe')?.value) || 1;
  const conversion_roe = Number(
    this.portAgentForm.get('conversion_pda_rate')?.value || 1,
  );

  let baseValue: number | null = null;

  // Handle 'ToCurrency' and 'convertedToCurrency'
  if (conversion_type === 'ToCurrency') {
    if (type === 'agent') {
      baseValue = Number(service.value?.total) || null;
    } else if (type === 'system') {
      baseValue = Number(service.value?.systemTotal) || 0;
    }
    return baseValue !== null
      ? parseFloat((baseValue * roe).toFixed(2))
      : null;
  } else if (conversion_type === 'convertedToCurrency') {
    if (type === 'agent') {
      baseValue =
        this.fromCurrency === this.convertedFromCurrency
          ? Number(service.value?.total) * conversion_roe || null
          : Number(service.value?.total) * roe * conversion_roe;
    } else if (type === 'system') {
      baseValue =
        this.fromCurrency === this.convertedFromCurrency
          ? Number(service.value?.systemTotal) * conversion_roe || null
          : Number(service.value?.systemTotal) * roe * conversion_roe;
    }

    return baseValue !== null ? parseFloat(baseValue.toFixed(2)) : null;
  }
  return null;
}
  // methos to calculte the system and agent totals in from and to currencies
getSystemAndAgentTotal(type: string, conversion_type: string): number | null {
  const pdaRoe = Number(this.portAgentForm.get('pda_roe')?.value) || 1;
  const conversionRate =
    Number(this.portAgentForm.get('conversion_pda_rate')?.value) || 1;

  let total = 0;

  if (conversion_type === 'ToCurrency') {
    if (type === 'system') {
      const systemTotal = this.getSystemGrandTotal() || null;
      if (systemTotal === null) {
        return null;
      }
      total = systemTotal * pdaRoe;
    } else if (type === 'agent') {
      // Sum custom AED overrides when available; otherwise use default ROE conversion
      let hasValue = false;
      const calculatedTotal = this.serviceListFormArray.controls.reduce((sum, ctrl) => {
        if (this.customAgentAedValues.has(ctrl)) {
          hasValue = true;
          return sum + (this.customAgentAedValues.get(ctrl) || 0);
        }
        const usdVal = Number(ctrl.value?.total);
        if (!isNaN(usdVal) && usdVal !== 0) {
          hasValue = true;
        }
        return sum + (isNaN(usdVal) ? 0 : usdVal * pdaRoe);
      }, 0);

      if (!hasValue && this.agentServiceGrandTotal === null) {
        return null;
      }
      total = calculatedTotal;
    }
  } else if (conversion_type === 'convertedToCurrency') {
    if (type === 'system') {
      const systemTotal = this.getSystemGrandTotal() || null;
      if (systemTotal === null) {
        return null;
      }
      if (this.convertedFromCurrency !== this.fromCurrency) {
        total = systemTotal * pdaRoe * conversionRate;
      } else {
        total = systemTotal * conversionRate;
      }
    } else if (type === 'agent') {
      const agentTotal = this.agentServiceGrandTotal || null;
      if (agentTotal === null) {
        return null;
      }
      if (this.convertedFromCurrency !== this.fromCurrency) {
        total = agentTotal * pdaRoe * conversionRate;
      } else {
        total = agentTotal * conversionRate;
      }
    }
  }

  return parseFloat(total.toFixed(2));
}

  // method to get the meraki total amount
  getMerakiPdaAmount(): number {
    const roe = Number(this.portAgentForm.get('pda_roe')?.value) || 1;
    const conversionRate =
      Number(this.portAgentForm.get('conversion_pda_rate')?.value) || 1;
    if (this.portAgentForm.get('pmt_curr_from')?.value === this.fromCurrency) {
      return this.merakiServiceGrandTotal;
    } else if (
      this.portAgentForm.get('pmt_curr_from')?.value === this.toCurrency
    ) {
      return this.merakiServiceGrandTotal * roe;
    } else if (
      this.portAgentForm.get('pmt_curr_from')?.value ===
        this.convertedToCurrency &&
      this.convertedFromCurrency === this.fromCurrency
    ) {
      return this.merakiServiceGrandTotal * conversionRate;
    } else if (
      this.portAgentForm.get('pmt_curr_from')?.value ===
        this.convertedToCurrency &&
      this.convertedFromCurrency === this.toCurrency
    ) {
      return this.merakiServiceGrandTotal * roe * conversionRate;
    }
    return 0;
  }

  // method to show the converted currency marque
  shouldShowConvertedCurrencyMarquee(): boolean {
    const form = this.portAgentForm;
    return !!(
      form.get('converted_curr_from')?.value &&
      form.get('converted_curr_to')?.value &&
      form.get('conversion_pda_rate')?.value &&
      (form.get('converted_curr_from')?.value !==
        form.get('pda_currency_from')?.value ||
        form.get('converted_curr_to')?.value !==
          form.get('pda_currency_to')?.value)
    );
  }

    isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
